import {
  Component,
  Inject,
  OnInit,
  signal,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ViewChild,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { fromByteArray } from 'base64-js';
import { saveAs as importedSaveAs } from 'file-saver';
import * as moment from 'moment';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AssessmentNote } from '../../_models/assessmentNote';
import { CompletionPeriod } from '../../_models/completion-period';
import { DictionaryItem } from '../../_models/dictionaryItem';
import { ImplementationControlStatement } from '../../_models/implementationControlStatement';
import {
  Attachment,
  Project,
  ProjectControlItem,
  User,
} from '../../_models/index';
import { Policy } from '../../_models/policy';
import { TenantPermissions } from '../../_models/tenantPermissions';
import { ActionItemService } from '../../_services/actionItem.service';
import { DictionaryService } from '../../_services/dictionary.service';
import { ImplementationControlStatementService } from '../../_services/implementationControlStatement.service';
import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  FileBlobService,
  ProjectControlItemService,
  TenantService,
  UserService,
} from '../../_services/index';
import { IndexConfigService } from '../../_services/index.config.service';
import { PolicyService } from '../../_services/policy.service';
import { RecommendedSolutionService } from '../../_services/recommendedSolution.service';
import { ReferenceResourceService } from '../../_services/referemceResource.service';
import { SignalRService } from '../../_services/signalR.service';
import {
  Customs,
  DatesHelper,
  ImplementationStatus,
  Level,
  LoginHelper,
  Recurring,
  Role,
  StringsHelper,
  EncryptHelper,
} from '../../helpers';
import { EvidenceRecurring } from '../../helpers/evidenceRecurring';
import { AddUrlComponent } from '../addUrl/add-url.component';
import { CreatePoamTemplateComponent } from '../createPoamTemplate';
import { DocumentSelectComponent } from '../documentSelect';
import { PromptComponent } from '../prompt/prompt.component';
import { SelectActionPlanTemplateComponent } from '../selectActionPlanTemplate/select-action-plan-template.component';
import { SelectImplementationControlStatementComponent } from '../selectImplementationControlStatement/select-implementation-control-statement.component';
import { SelectPolicyComponent } from '../selectPolicy/select-policy.component';
import { IntegrationsService } from '../../_services';
import { Integration } from '../../_models/integration';
import { Table } from 'primeng/table';
import { trigger, state, style, transition, animate } from '@angular/animations';

import { ClientITProfile } from '../../_models/clientITProfile';
import { GuidanceDialogComponent } from '../guidance-dialog/guidance-dialog.component';
import { WorkstreamService } from '../../_services/workstream.service';
import { WorkstreamItemComponent } from '../workstreamItem';
import {SelectDictionaryItemComponent} from "../selectDictionaryItem/select-dictionary-item.component";
import {SelectProjectControlItemComponent} from "../selectProjectControlItem/select-project-control-item.component";
import {ViewFileComponent} from "../viewFile/viewFile.component";
import {AddSignatureComponent} from "../addSignature/addSignature.component";

const now = new Date();

@Component({
    standalone: false,
  selector: 'project-control-item-component',
  templateUrl: 'project.control.item.component.html',
  styleUrls: ['./project.control.item.component.scss'],
  providers: [DialogService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('expandCollapse', [
      state('collapsed', style({
        height: '0px',
        overflow: 'hidden',
        opacity: 0,
        display: "none",
      })),
      state('expanded', style({
        height: '*',
        opacity: 1
      })),
      transition('collapsed <=> expanded', [
        animate('200ms ease-in-out')
      ])
    ])
  ]
})
export class ProjectControlItemComponent implements OnInit {
  loading = false;
  loadingCounter = 0;
  projectId: number;
  projectControlItemId: string;
  projectControlItem: ProjectControlItem;
  //@Input() placeholder: string;
  @ViewChild('table') table!: Table;
  isNotConsultant: boolean;
  detailsDiv = { hidden: false };
  isUser: boolean;
  isManager: boolean;
  canReview: boolean;
  canEditAssessmentNotes: boolean;
  isManagerUser: boolean;
  CurrentDate: Date;
  isNotHiddenForComplianceArea: boolean;
  supportedViewExtensions = ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'svg', 'bmp'];
  isSimpleView: boolean;
  currentUser: User;
  fileBlob1: File;
  fileBlob2: File;
  fileBlob3: File;
  clientNotes: string = '';
  consultantNotes: string = '';
  draftMessage: string = '';
  settings: any;
  advisors: User[];
  workstreamUsers: User[];
  clients: User[];
  integrations: Integration[] | undefined;
  filteredIntegrations: Integration[] | undefined;
  selectedPolicies: any[] = [];
  selectedProcedures: any[] = [];
  policies: Policy[] = [];
  implementationControlStatementSets: any[] = [];
  actionPlanTemplates: any[] = [];
  actionPlanTemplatesMap = {};
  upcomingDate: any;
  actionPlanForm: FormGroup;
  assessmentNoteForm: FormGroup;
  canSeePracticeGuidance: boolean = false;
  isImplementationSontrolStatementsEnabled: boolean = false;
  vendors: DictionaryItem[] = [];
  services: DictionaryItem[] = [];
  securityTopics: string[] = [];
  filteredServices: DictionaryItem[] = [];
  isResponsibilityEdit = false;
  isRecommendationsVisible = false;
  riskAssessmentVisible = false;
  securityAssessmentVisible = false;
  isCustomerResponsibilityRequired = false;
  canAddPolicies = false;
  potentialRecommendedSolutions: any[] = [];
  externalEvidenceEnabled = false;
  repeatVisible = false;
  readonly panelOpenState = signal(false);
  readonly nestedPanelOpenState = signal(false);
  expandedAccordions = [[], [], [], [], [], [], []];
  icsLoadingMessage = false;
  iscComponentStatuses = {2: 'Implemented', 1: 'Partially', 0: 'Not Started'};
  assessmentObjectives: string[] = [];
  criteriaItems: any[] = [];
  criteriaItemsMet = 0;
  criteriaSum = 0;
  criteriaTotalSum = 0;
  recommendedSolutionCols: any[] = [
    { 'field': 'listLogoFileName', 'header': '' },
    { 'field': 'parent', 'header': 'Vendor' },
    { 'field': 'name', 'header': 'Name', width: '10%' },
    { 'field': 'details', 'header': 'Description' },
    { 'field': 'inheritance', 'header': 'Responsibility' },
    { 'field': 'price', 'header': 'Price' },
    { 'field': 'configDetails', 'header': 'Config Details' },
    { 'field': 'contact', 'header': 'Contact', width: '20%' },
  ];
  referenceResources: any[];
  referenceResourceCols: any[] = [
    { 'field': 'name', 'header': 'Reference Resource' },
    { 'field': 'sourceProvider', 'header': 'Source/Provider' },
    { 'field': 'note', 'header': 'Notes' },
  ];
  showAllItems = false;
  evidences = [];

  implementationStatuses: any = {
    0: 'None',
    1: 'Implemented',
    2: 'Partially Implemented',
    3: 'Planned',
    4: 'Alternative Implementation',
    5: 'Not Applicable',
    7: 'Not Implemented'
    //6: "Ongoing",
  };

  actionItemStatuses: any = {
    0: 'Not Started',
    1: 'In-Progress',
    2: 'Resolved',
    3: "Awaiting Review",
    4: "Reviewed - Not POAM"
  };

  assessmentNoteStatuses: any = {
    0: 'Open',
    1: 'In-Progress',
    2: 'Addressed',
  };

  deviceCols: any[] = [
    {field: 'deviceName', header: 'Device Name'},
    {field: 'type', header: 'Type'},
    {field: 'manufacturer', header: 'Manufacturer'},
    {field: 'model', header: 'Model'},
    {field: 'serialNumber', header: 'Serial Number'},
    {field: 'ip', header: 'IP'},
    {field: 'mac', header: 'MAC'},
    {field: 'puid', header: 'PUID'},
    {field: 'owner', header: 'Owner'},
    {field: 'location', header: 'Location'},
];

  reviewedByConsultantRanges: Date[];
  completedRanges: Date[];
  recurringList: any[] = [];
  evidenceRecurringList: any[] = [];
  //TODO : Migration no any
  originalProjectControlItem: any;
  prevDate: Date = null;
  project: Project;
  selectPolicyDialogRef: MatDialogRef<SelectPolicyComponent>;
  selectImplementationControlStatementDialogRef: MatDialogRef<SelectImplementationControlStatementComponent>;
  selectActionPlanTemplateDialogRef: MatDialogRef<SelectActionPlanTemplateComponent>;
  rowGroupMetadata: any;
  selectedTab = 0;

  collapsedSections: any = { 'Collaboration': true };

  evidenceCols: any[] = [
    { 'field': 'date', 'header': 'Date', width: '15em' },
    { 'field': 'name', 'header': 'Artifact' },
    { 'field': 'submitterId', 'header': 'Submitter' },
    { 'field': 'provider', 'header': 'Source/Provider' },
    { 'field': 'findings', 'header': 'Findings' },
    { 'field': 'note', 'header': 'Notes' },
  ];
  assessmentNoteAttachmentCols: any[] = [
    { 'field': 'date', 'header': 'Date', width: '8em' },
    { 'field': 'name', 'header': 'Evidence' },
    { 'field': 'note', 'header': 'Notes' },
  ];
  actionPlanAttachmentCols: any[] = [
    { 'field': 'date', 'header': 'Date', width: '8em' },
    { 'field': 'name', 'header': 'Evidence' },
    { 'field': 'note', 'header': 'Notes' },
  ];
  cols: any[] = [
    { 'field': 'practice', 'header': 'Practice', width: '20%' },
    { 'field': 'label', 'header': 'Label', width: '20%' },
    { 'field': 'description', 'header': 'Description' },
    { 'field': 'source', 'header': 'Source', width: '5%' },
    {
      'field': 'implementationStatus',
      'header': 'Implementation Status',
      width: '10%',
    },
  ];
  actionPlanCols: any[] = [
    { 'field': 'value.name', 'header': 'Name' },
    { 'field': 'value.weaknessDescription', 'header': 'Description' },
    {
      'field': 'value.currentStatus',
      'header': 'Current Status',
      width: '35em',
    },
    {
      'field': 'value.scheduledCompletionDate',
      'header': 'Scheduled Completion Date',
      width: '10em',
    },
    {
      'field': 'value.assessmentNotes',
      'header': 'Related Assessments',
      width: '25em',
    },
  ];

  assessmentNoteCols: any[] = [
    { 'field': 'value.assessmentNoteId', 'header': 'ID', width: '15em' },
    { 'field': 'value.date', 'header': 'Date', width: '15em' },
    { 'field': 'value.finding', 'header': 'Finding' },
    { 'field': 'value.name', 'header': 'Assessor', width: '25em' },
    { 'field': 'value.title', 'header': 'Title', width: '25em' },
  ];

  defaultGroups = ['L1', 'L2', 'L3', 'L4', 'L5'];
  expanded = { 'L1': true, 'L2': true, 'L3': true, 'L4': true, 'L5': true };
  expandedActionPlans = {};
  visibility: any = {};
  subItems: ProjectControlItem[];
  selectedCompletionPeriod: CompletionPeriod;
  parentControlItem: ProjectControlItem;
  subitemSummary: {
    level: string;
    completed: number;
    total: number;
    percent: number;
  }[] = [];
  levelReached: string;
  allSubitemsImplemented: boolean = true;
  allSubitemsCompleted: boolean = true;
  users: User[];
  userMap = {};
  advisorCompany: any;
  organizationalParametersQuestions: string[];
  organizationalParameters = [];
  controlOriginationQuestions: string[];
  controlOrigination = [];
  controlOriginationSpecialParts: string[] = null;
  controlOriginationExplanationVisible = false;
  linkedImplementationControlStatement = '';
  sharedResponsibilityForm: FormGroup;
  tenantPermissions: TenantPermissions = {};
  controlItemDialogRef: DynamicDialogRef | undefined;
  clientProfile: ClientITProfile | null = null;
  workstreamItem: WorkstreamItemComponent;

  guidanceLoading: { [key: string]: boolean } = {};
  guidanceOutputs: { [serviceId: string]: string } = {};
  guidanceLoadingMessage = false;

  private lastGuidanceRequest: { [key: string]: number } = {};
  private lastIcsRequest;
  private icsOutput;
  private guidanceDebounceTimeout: any;
  private readonly GUIDANCE_COOLDOWN_MS = 2000;
  private readonly DEBOUNCE_MS = 500;

  customDate: Date | null = null;
  customDateOption = { isCustom: true };
  today = new Date();
  localDueDate: Date | null = null;


  constructor(
    public dialogRef: MatDialogRef<ProjectControlItemComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public route: ActivatedRoute,
    public projectControlItemService: ProjectControlItemService,
    public userService: UserService,
    public alertService: AlertService,
    public fileBlobService: FileBlobService,
    public authenticationService: AuthenticationService,
    public dialog: MatDialog,
    public formBuilder: FormBuilder,
    public tenantService: TenantService,
    public clientProfileService: ClientProfileService,
    public policyService: PolicyService,
    public referenceResourcesService: ReferenceResourceService,
    public implementationControlStatementService: ImplementationControlStatementService,
    public actionPlanTemplateService: ActionItemService,
    public signalRService: SignalRService,
    public dictionaryService: DictionaryService,
    public config: IndexConfigService,
    public dialogService: DialogService,
    public integrationsService: IntegrationsService,
    private cdr: ChangeDetectorRef,
    private workstreamService: WorkstreamService
  ) {
    this.projectId = route.snapshot.params['projectId'];
    this.projectControlItemId = route.snapshot.params['projectControlItemId'];
    this.sharedResponsibilityForm = this.formBuilder.group({
      responsibility: [null],
      vendorId: [null, [Validators.required]],
      serviceId: [null, [Validators.required]],
      securityTopic: [null],
      contacts: [''],
      elixir: ['']
    });
    this.sharedResponsibilityForm.setValue({
      responsibility: null,
      vendorId: null,
      serviceId: null,
      securityTopic: null,
      contacts: '',
      elixir: '',
    });
  }

  downloadAssessmentNotes(projectControlItemId: number, sectionType: string): void {
    console.log('Downloading:', projectControlItemId, sectionType);
    this.projectControlItemService.exportAssessmentNotes(projectControlItemId, sectionType).subscribe(
      (blob: Blob) => {
        const fileName = `Assessment-${sectionType}.docx`;
        const file = new Blob([blob], {
          type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(file);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },

      (error) => {
        console.error('Actual error:', error);
        this.alertService.error('Frontend: Error downloading assessment notes.');
      }
    );
  }


  filterIntegrations() {
    if (!this.integrations) {
      console.error('Integrations array is undefined');
      return;
    }

    const { complianceAreaControlId, complianceAreaName } =
      this.data.projectControlItem.controlItem;
    this.filteredIntegrations = this.integrations.filter(
      (integration) =>
        integration.category === 'Evidence' &&
        integration.settings.complianceAreaControlId ===
        complianceAreaControlId &&
        integration.settings.complianceAreaName === complianceAreaName
    );
  }

  resetMappingStates() {
    this.originalProjectControlItem.sources.forEach(item => item.hidden = false);
    this.originalProjectControlItem.targets.forEach(item => item.hidden = false);
  }
  getSourceForICS2() {
    const sources = this.originalProjectControlItem.sources;
    for (const source of sources) {
      if (source.ics2) {
        return {
          fromComplianceAreaName: source.fromComplianceAreaName,
          fromControlItemName: source.fromControlItemName
        };
      }
    }
    return null;
  }
  getSourceForICS3() {
    const sources = this.originalProjectControlItem.sources;
    for (const source of sources) {
      if (source.ics3) {
        return {
          fromComplianceAreaName: source.fromComplianceAreaName,
          fromControlItemName: source.fromControlItemName
        };
      }
    }
    return null;
  }
  getSourceForICS1() {
    const sources = this.originalProjectControlItem.sources;
    for (const source of sources) {
      if (source.ics1) {
        return {
          fromComplianceAreaName: source.fromComplianceAreaName,
          fromControlItemName: source.fromControlItemName
        };
      }
    }
    return null;
  }

  ngOnInit() {
    this.selectedTab = this.data.selectedTab || 0;
    if (this.data.selectedTab || this.data.selectedItem) {
      this.expandedAccordions[this.selectedTab][this.data.selectedItem] = true;
    }
    //this.selected
    this.CurrentDate = new Date(Date.UTC(
      new Date().getUTCFullYear(),
      new Date().getUTCMonth(),
      new Date().getUTCDate()
    ));
    this.loadingCounter = 4;
    this.signalRService.init();
    this.signalRService.connection.subscribe((connection) => {
      if (connection) {
        debugger;
      }
    });
    this.loadingCounter = 3;
    this.tenantService.getCurrent().subscribe((p) => {
      this.tenantPermissions = p;
    });

    this.actionPlanForm = this.formBuilder.group({
      actionPlans: this.formBuilder.array([]),
    });

    this.assessmentNoteForm = this.formBuilder.group({
      assessmentNotes: this.formBuilder.array([]),
    });
    this.loadingCounter--;
    this.loadingCounter--;
    this.loadDictionaries();
    this.recurringList = [];
    for (let i = 0; i <= Recurring.Yearly; i++) {
      this.recurringList.push({ label: Recurring[i].toString(), value: i });
    }
    this.evidenceRecurringList = [];
    for (let i = 0; i <= EvidenceRecurring.Continuous; i++) {
      this.evidenceRecurringList.push({
        label: EvidenceRecurring[i].toString(),
        value: i,
      });
    }
    console.log('DATA OF PROJECT =>>>', this.data.projectControlItem);
    this.integrationsService.getAll().subscribe((integrations) => {
      if (!integrations) {
        console.error('No integrations received from service');
        return;
      }
      this.integrations = integrations;
      this.filterIntegrations();
    });
    this.reviewedByConsultantRanges = [];
    this.completedRanges = [];

    this.projectControlItem = Object.assign({}, this.data.projectControlItem);
    this.originalProjectControlItem = Object.assign(
      {},
      this.data.projectControlItem
    );
    this.clientProfileService.getPublicSettings(LoginHelper.getTenantName()).subscribe(s => {
      this.settings = s;
      this.updateScore();
    });
    console.log('Control ID:', this.originalProjectControlItem?.projectId);
    console.log('Original Project Control Item:', this.originalProjectControlItem);
    console.log('ProjectControlItemId:', this.originalProjectControlItem?.projectControlItemId);
    if (this.originalProjectControlItem?.dueDate) {
      const d = new Date(this.originalProjectControlItem.dueDate);
      this.localDueDate = new Date(
        d.getUTCFullYear(),
        d.getUTCMonth(),
        d.getUTCDate(),
      );
    }
    else{
      this.localDueDate = new Date();
    }


    this.referenceResourcesService
      .getReferenceResources(
        this.originalProjectControlItem.controlItem.controlItemId
      )
      .subscribe((i) => (this.referenceResources = i));
    this.originalProjectControlItem.primarySource =
      this.originalProjectControlItem.sources == null
        ? null
        : this.originalProjectControlItem.sources.find((s) => s.isPrimary);
    this.subItems = this.data.subItems;
    this.parentControlItem = this.data.parentControlItem;

    this.subItems = this.subItems.sort((a, b) =>
      a.controlItem.level > b.controlItem.level
        ? 1
        : a.controlItem.level < b.controlItem.level
          ? -1
          : a.controlItem.complianceAreaControlId >
            b.controlItem.complianceAreaControlId
            ? 1
            : -1
    );
    this.allSubitemsImplemented = true;
    this.allSubitemsCompleted = true;
    this.loadActionPlanTemplates();
    this.subItems.forEach((g) => {
      this.allSubitemsImplemented =
        this.allSubitemsImplemented &&
        g.implementationStatus == ImplementationStatus.Implemented;
      const upcomingDueDate =
        this.getUpcomingDate(g).format('Y-MM-DDT00:00:00');
      this.allSubitemsCompleted =
        this.allSubitemsCompleted &&
        (g.completionPeriods
          .filter((x) => moment(x.dueDate).isSame(upcomingDueDate + 'Z'))
          .map((x) => x.isCompleted)[0] ||
          false);
      if (this.defaultGroups.indexOf(g.controlItem.level) < 0) {
        this.defaultGroups.push(g.controlItem.level);
        this.expanded[g.controlItem.level] = true;
        this.defaultGroups = this.defaultGroups.sort((a, b) =>
          a > b ? 1 : -1
        );
      }
    });

    this.updateRowGroupMetaData();
    //this.originalProjectControlItem.reviewRequired = false;

    this.tenantService.getCurrent().subscribe((data) => {
      this.canSeePracticeGuidance = data.isPracticeGuidanceEnabled;
      this.isImplementationSontrolStatementsEnabled =
        data.isImplementationControlStatementsEnabled;
      this.riskAssessmentVisible =
        (complianceArea.riskAssessmentVisibility == 2 ||
          (complianceArea.riskAssessmentVisibility == 1 && isAdvisor)) &&
        data.isRiskAssessmentTabEnabled;
      this.securityAssessmentVisible =
        (complianceArea.securityAssessmentVisibility == 2 ||
          (complianceArea.securityAssessmentVisibility == 1 && isAdvisor)) &&
        data.isSecurityAssessmentTabEnabled;
    });

    this.originalProjectControlItem.upcomingDueDate = this.getUpcomingDate(
      this.originalProjectControlItem
    ).format('Y-MM-DDT00:00:00');

    this.originalProjectControlItem.completionPeriods.forEach((p) => {
      p.dueDate = <any>moment.utc(p.dueDate).format('Y-MM-DDT00:00:00');
      if (p.actualDate) {
        p.actualDate = <any>moment.utc(p.actualDate).format('Y-MM-DDT00:00:00');
      }
      if (p.completedInRizkly) {
        p.completedInRizkly = <any>(
          moment.utc(p.completedInRizkly).format('Y-MM-DDT00:00:00')
        );
      }
    });

    this.originalProjectControlItem.attachments.forEach((a) => {
      if (a.name.indexOf('document://') == 0) {
        (<any>a).fileName = a.name.split('\\').pop();
        let path = a.name.match(/^document:\/\/(.*)\\[^\\]*$/i)[1] || '';
        path = path === 'null' ? '\\' : path;
        (<any>a).url =
          this.config.api +
          '/api/attachments/file?token=' +
          LoginHelper.getFileToken() +
          '&name=' +
          encodeURIComponent((<any>a).fileName) +
          '&path=' +
          encodeURIComponent(path);
      }
    });

    if (this.originalProjectControlItem.controlItem.complianceArea.isFedRamp) {
      this.organizationalParametersQuestions = (
        this.originalProjectControlItem.controlItem.organizationalParameters ||
        ''
      )
        .split('\n')
        .map((q) => q.trim())
        .filter((q) => q);
      let oldValueParts = [];
      try {
        oldValueParts = JSON.parse(
          this.originalProjectControlItem.organizationalParameters || '[]'
        );
      } catch (e) {
        //debugger;
      }
      this.organizationalParameters =
        this.organizationalParametersQuestions.map(
          (q, i) => oldValueParts[i] || ''
        );

      this.originalProjectControlItem.subItems.forEach((s) => {
        (<any>s).organizationalParametersQuestions = (
          (<any>s).controlItem.organizationalParameters || ''
        )
          .split('\n')
          .map((q) => q.trim())
          .filter((q) => q);
        let oldValueParts = [];
        try {
          oldValueParts = JSON.parse((<any>s).organizationalParameters || '[]');
        } catch (e) {
          //debugger;
        }
        (<any>s).organizationalParameters = (<any>(
          s
        )).organizationalParametersQuestions.map(
          (q, i) => oldValueParts[i] || ''
        );
      });

      this.controlOriginationQuestions = (
        this.originalProjectControlItem.controlItem.controlOrigination || ''
      )
        .split('\n')
        .map((q) => q.replace('☐', '').trim())
        .filter((q) => q);
      oldValueParts = [];
      try {
        oldValueParts = JSON.parse(
          this.originalProjectControlItem.controlOrigination || '[]'
        );
      } catch (e) {
        //debugger;
      }
      this.controlOrigination = this.controlOriginationQuestions.map(
        (q, i) => oldValueParts[i] || false
      );
      let lastControlOriginationQuestion =
        this.controlOriginationQuestions[
        this.controlOriginationQuestions.length - 1
        ];
      if (
        lastControlOriginationQuestion &&
        ((lastControlOriginationQuestion.indexOf('{') >= 0 &&
          lastControlOriginationQuestion.indexOf('}') >= 0) ||
          lastControlOriginationQuestion.indexOf('Click here to enter text.') >=
          0)
      ) {
        lastControlOriginationQuestion = lastControlOriginationQuestion.replace(
          'Click here to enter text.',
          '{Click here to enter text.}'
        );
        lastControlOriginationQuestion = lastControlOriginationQuestion.replace(
          '{{',
          '{'
        );
        lastControlOriginationQuestion = lastControlOriginationQuestion.replace(
          '}}',
          '}'
        );
        const parts1 = lastControlOriginationQuestion.split('{');
        const parts2 = parts1[1].split('}');
        const parts3 = parts2[1].split('Date of Authorization');
        this.controlOriginationSpecialParts = [parts1[0], parts2[0], parts3[0]];
        if (parts3.length === 2) {
          this.controlOriginationSpecialParts.push(parts3[1]);
        }
        this.controlOriginationExplanationVisible =
          (this.originalProjectControlItem.controlOriginationExplanation !=
            null &&
            this.originalProjectControlItem.controlOriginationExplanation !=
            '') ||
          this.originalProjectControlItem.controlOriginationExplanationDate !=
          null;
      }

      if (this.parentControlItem) {
        const parentControlOriginationQuestions = (
          this.parentControlItem.controlItem.controlOrigination || ''
        )
          .split('\n')
          .map((q) => q.replace('☐', '').trim())
          .filter((q) => q);
        oldValueParts = [];
        try {
          oldValueParts = JSON.parse(
            this.parentControlItem.controlOrigination || '[]'
          );
        } catch (e) {
          //debugger;
        }
        const parentControlOrigination = parentControlOriginationQuestions.map(
          (q, i) => oldValueParts[i] || false
        );
        this.isCustomerResponsibilityRequired =
          !!parentControlOriginationQuestions.find(
            (q, i) =>
              parentControlOrigination[i] &&
              q.toLowerCase().indexOf('customer') >= 0
          );
      }
    }

    let completionPeriod = this.originalProjectControlItem.recurring === 0 ? null :
      this.originalProjectControlItem.completionPeriods.find((i) =>
        moment(moment.utc(i.dueDate).format('Y-MM-DDT00:00:00') + 'Z').isSame(
          this.originalProjectControlItem.upcomingDueDate + 'Z'
        )
      );
    if (this.originalProjectControlItem.recurring !== 0 && !completionPeriod) {
      completionPeriod = {
        actualDate: null,
        completedInRizkly: null,
        dueDate: this.originalProjectControlItem.upcomingDueDate,
        isCompleted: false,
        completionPeriodId: 0,
        projectControlItemId: this.projectControlItem.projectControlItemId,
        note: '',
        temporary: true // Experiment
      };
      this.originalProjectControlItem.completionPeriods.push(completionPeriod);
    }
    this.completionPeriodChange(completionPeriod);
    if (completionPeriod) {
      completionPeriod.isCurrent = true;
    }

    this.project = Object.assign({}, this.data.project);

    if (this.originalProjectControlItem.clientNotes != null) {
      this.clientNotes = this.originalProjectControlItem.clientNotes
        .replace(/\r\n\r\n/g, '\r\n')
        .replace(/\r\n/g, '\r\n\r\n');
    }

    if (this.originalProjectControlItem.consultantNotes != null) {
      this.consultantNotes = this.originalProjectControlItem.consultantNotes
        .replace(/\r\n\r\n/g, '\r\n')
        .replace(/\r\n/g, '\r\n\r\n');
    }

    this.prevDate = this.originalProjectControlItem.dueDate;

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    const complianceArea =
      this.originalProjectControlItem.controlItem.complianceArea;
    const isAdvisor =
      (this.currentUser.role &
        (Role.AdvisorStaff |
          Role.AdvisorStaff |
          Role.PrimaryAdvisorLead |
          Role.PlatformSupport)) !==
      0;

    this.canAddPolicies = this.currentUser.role != Role.Assessor;
    this.isNotConsultant = !(
      (this.currentUser.role & Role.AdvisorStaff) != 0 ||
      (this.currentUser.role &
        (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) !=
      0
    );
    this.isManager =
      (this.currentUser.role & (Role.Manager | Role.PrimaryManager)) != 0;
    this.canReview =
      ((this.currentUser.role &
        (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) !=
        0 ||
        this.originalProjectControlItem.assignedConsultantIdList.indexOf(
          this.currentUser.userId
        ) >= 0) &&
      this.originalProjectControlItem.reviewRequired;
    this.canEditAssessmentNotes =
      (this.currentUser.role &
        (Role.Assessor |
          Role.AdvisorLead |
          Role.PrimaryAdvisorLead |
          Role.PlatformSupport |
          Role.PrimaryManager)) !=
      0;
    this.isUser = (this.currentUser.role & Role.User) != 0;
    this.isManagerUser =
      (this.currentUser.role & (Role.Manager | Role.PrimaryManager)) != 0 ||
      (this.currentUser.role & Role.User) != 0;

    this.isNotHiddenForComplianceArea =
      this.originalProjectControlItem.controlItem.complianceArea.isExtended;

    this.userService.getAllShort().subscribe((users) => {
      this.users = users;
      users.forEach((u) => (this.userMap[u.userId] = u));
      this.clients = users.filter((user) =>
        this.project.assignedUsers.find((a) => a.userId == user.userId)
      ); //.filter(user => (user.role & Role.User) != 0);
      this.advisors = users.filter(
        (user) =>
          this.project.assignedUsers.find((a) => a.userId == user.userId) &&
          (user.role &
            (Role.AdvisorStaff |
              (Role.AdvisorLead |
                Role.PrimaryAdvisorLead |
                Role.PlatformSupport))) !=
          0
      );
      this.workstreamUsers = users.filter(
        (user) =>
          this.project.assignedUsers.find((a) => a.userId == user.userId) &&
          (user.role & Role.Engineer) != 0
      );
      this.loadingCounter--;
    });
    this.loadingCounter--;

    //this.projectControlItem.reviewRequired = false;
    console.log(this.projectControlItem.completionPeriods);
    this.originalProjectControlItem.completed =
      this.projectControlItem.completionPeriods.filter((d) => d.isCompleted)
        .length > 0;

    if (
      (this.isManager || this.isUser) &&
      this.originalProjectControlItem.reviewedByConsultant
    ) {
      //this.projectControlItem.reviewedByConsultant = false;
      //this.originalProjectControlItem.reviewedByConsultant = false;
      //this.onSave(true);
      //TODO :: what was this for
    }
    const dates = DatesHelper.getDates(this.originalProjectControlItem);

    this.originalProjectControlItem.completionPeriods = dates.map((d) => {
      return (
        this.projectControlItem.completionPeriods.find((i) =>
          moment(moment.utc(i.dueDate).format('Y-MM-DDT00:00:00') + 'Z').isSame(
            d.value + 'Z'
          )
        ) ||
        <CompletionPeriod>{
          dueDate: d.value,
          isCompleted: false,
          note: null,
          actualDate: null,
          projectControlItemId: this.projectControlItem.projectControlItemId,
          completionPeriodId: 0,
          completedInRizkly: null,
          temporary: true,
        }
      );
    });

    if (this.originalProjectControlItem.recurring !== 0) {
      this.completionPeriodChange(
        this.originalProjectControlItem.completionPeriods.find((t) =>
          moment(moment.utc(t.dueDate).format('Y-MM-DDT00:00:00') + 'Z').isSame(
            this.originalProjectControlItem.upcomingDueDate + 'Z'
          )
        )
      );
    }

    if (this.originalProjectControlItem.completionPeriods.length) {
      const today = new Date();

      const nextPeriod = this.originalProjectControlItem.completionPeriods
        .filter(p => new Date(p.dueDate) >= today)
        .sort((a, b) => new Date(a.dueDate).getTime() - new Date(b.dueDate).getTime())
      [0];
      console.log("next period should be ", nextPeriod);
      if (nextPeriod) {
        this.completionPeriodChange(nextPeriod);
      }
    }



    const dateNow = new Date(Date.now());

    const daysDelta = 0;
    const currentDate = dateNow;

    this.originalProjectControlItem.relatedProjectControlItems =
      this.originalProjectControlItem.relatedProjectControlItems || [];
    this.originalProjectControlItem.dependenciesProjectControlItems =
      this.originalProjectControlItem.dependenciesProjectControlItems || [];

    this.assessmentObjectives = (this.originalProjectControlItem.assessmentObjective || '').split('\n').map(r => r.trim()).filter(r => r[0] == '[');
    try {
      var criteriaValues = [];
      try{
        criteriaValues = JSON.parse(this.originalProjectControlItem.criteriaResults);
      }
      catch {
        criteriaValues = [];
      }

      this.criteriaItems = [...(this.originalProjectControlItem.controlItem.criteria + '\r\n').matchAll(/([\d]+.*);\s?([\d]+)\s*[\r\n]+/g)].map((r, i) => ({text: r[1], value: parseInt(r[2], 10), userValue: criteriaValues[i] || ''}));
    } catch {
      this.criteriaItems = [];
    }
    this.refreshCriteria();
    try {
      this.originalProjectControlItem.findingsNotesList = JSON.parse(this.originalProjectControlItem.findingsNotes) || [];
    } catch (e) {
      this.originalProjectControlItem.findingsNotesList = [];
    }
    try {
      this.originalProjectControlItem.recommendationsList = JSON.parse(this.originalProjectControlItem.recommendations) || [];
    } catch (e) {
      this.originalProjectControlItem.recommendationsList = [];
    }

    console.log('Policy get');
    this.policyService.getAllPolicys().subscribe((p) => {
      console.log('Policy set');
      this.policies = p;
      this.originalProjectControlItem.projectControlItemPolicies = this.originalProjectControlItem.projectControlItemPolicies || [];
      this.originalProjectControlItem.projectControlItemPolicies?.forEach((p) => {
        p.policy = this.policies.find(z => z.id == p.policyId);
        if (p.policy) {
          let currentTitle = null;
          let currentNumber = null;
          let currentSubTitle = null;
          let currentSubNumber = null;
          p.policy.policySections.forEach((s) => {
            const title = s.title;
            const num = s.number;
            const subTitle = s.subTitle;
            const subNumber = s.subNumber;
            if (s.title === currentTitle) {
              s.title = null;
            }
            if (s.number === currentNumber) {
              s.number = null;
            }
            if (s.subTitle === currentSubTitle) {
              s.subTitle = null;
            }
            if (s.subNumber === currentSubNumber) {
              s.subNumber = null;
            }
            currentTitle = title;
            currentNumber = num;
            currentSubTitle = subTitle;
            currentSubNumber = subNumber;
          });
        }
      });
      this.selectedPolicies = this.originalProjectControlItem.projectControlItemPolicies.filter(p => p.policy && p.kind == 0);
      this.selectedProcedures = this.originalProjectControlItem.projectControlItemPolicies.filter(p => p.policy && p.kind == 1);
      this.updatePolicyMappings();
      this.loadingCounter--;
    });

    this.implementationControlStatementService.getAllImplementationControlStatementSets().subscribe((p) => {
      this.implementationControlStatementSets = p;
      this.linkedImplementationControlStatement = (
        this.implementationControlStatementSets.flatMap(s => s.implementationControlStatements).find(
          (s) => this.project.implementationControlStatementSetIds.indexOf(s.implementationControlStatementSetId) >= 0 &&
            s.id == this.originalProjectControlItem.implementationControlStatementId
        ) || { text: '' }
      ).text;
    });

    if (this.originalProjectControlItem.actionPlans)
      this.originalProjectControlItem.actionPlans.forEach((a, i) => {
        a.number = i;
        this.addActionPlanGroup(a);
      });
    if (this.originalProjectControlItem.assessmentNotes)
      this.originalProjectControlItem.assessmentNotes.forEach((a) =>
        this.addAssessmentNoteGroup(a)
      );

    this.userService.getPublicManagers(LoginHelper.getTenantName()).subscribe((m) => {
      this.advisorCompany = m.consultantCompany;
    });

    this.clientProfileService.getClientProfiles(LoginHelper.getTenantName()).subscribe(profile => {
      this.clientProfile = profile;
    });
  }

  addActionPlanGroup(model: any, visible: boolean = false) {
    model.projectId = this.originalProjectControlItem.projectId;
    model.controlItemId = null;
    model.owner = null;
    const group = this.formBuilder.group({
      name: [null, [Validators.required]],
      weaknessDescription: [null, [Validators.required]],
      howIdentified: [null, [Validators.required]],
      responsibleParty: [null, [Validators.required]],
      identificationDate: [null, [Validators.required]],
      currentStatus: [null, [Validators.required]],
      scheduledCompletionDate: [null, [Validators.required]],
      actualCompletionDate: [null],
      remediationPlansActionsMilestones: [null, [Validators.required]],
      changesToRemediationPlansActionsMilestones: [null],
      comments: [null],
      actionPlanId: [null],
      projectControlItemId: [null],
      projectId: [null],
      controlItemId: [null],
      owner: [null],
      pOAMId: [null],
      typeBool: [true],
      createIncidentResponse: [false],
      riskLevel: [''],
      assessmentNotes: [[]],
      modifiedDate: [null],
      assessmentNoteIds: [''],
      actionPlanTemplateId: [null],
      impactedControls: [''],
      number: [0],
      attachments: [null],
      topic: [''],
      loe: [0],
      requirementOrGuidance: [''],
      affectedSystems: [''],
      source: [''],
      system: ['']
    });
    if (visible) {
      this.expandedActionPlans[model.number] = true;
    }
    (<FormArray>this.actionPlanForm.controls['actionPlans']).push(group);
    model.typeBool = model.type == 0;
    delete model.type;
    delete model.projectName;
    model.riskLevel = model.riskLevel || '';
    model.assessmentNotes = (model.assessmentNoteIds || '')
      .split(',')
      .filter((i) => i)
      .map((i) =>
        this.originalProjectControlItem.assessmentNotes.find(
          (n) => n.assessmentNoteId == parseInt(i)
        )
      );
    group.patchValue(model);
    this.updateScore();
  }

  getLocalDate(completedDate) {
    console.log(completedDate);

    return new Date(completedDate).toLocaleDateString();
  }

  onReviewRequiredChange() {
    this.originalProjectControlItem.reviewedByConsultant = false;
  }

  onReviewedByConsultantChange() {
    //this.originalProjectControlItem.reviewRequired = false;
    //this.originalProjectControlItem.reviewedByConsultant = !this.originalProjectControlItem.reviewedByConsultant;
    //this.originalProjectControlItem.assignedConsultant = this.advisors.find(c => c.userId == this.currentUser.userId);
    //this.reviewedByConsultantRanges.push(event);
  }

  onCompletedChange(event) {
    this.completedRanges.push(event);
  }

  onClose(item): void {
    this.dialogRef.close(item);
  }

  onAddConsultantNote() {
    this.consultantNotes = this.consultantNotes + this.GetNote();
    this.draftMessage = '';
  }

  getFullName(user: User) {
    return StringsHelper.getFullName(user);
  }

  getFullNameById(id: number) {
    return StringsHelper.getFullName(
      this.users.find((u) => u.userId == id) || <any>{}
    );
  }
  toggleShowAllItems() {
    this.showAllItems = !this.showAllItems;
    if (!this.showAllItems) {
      this.table.reset();
      this.cdr.detectChanges();
    }
  }

  onAddClientNote() {
    this.clientNotes = this.clientNotes + this.GetNote();
    this.draftMessage = '';
  }

  shouldAdvancedModeShow() {
    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    //console.log(this.currentUser);
    if ((this.currentUser.customs & Customs.SimpleView) != 0) {
      return false;
    }

    if (this.isNotConsultant) {
      return false;
    }

    return true;
  }

  public GetNote(): string {
    let dateTime = new Date(Date.now());
    let dateTimeString =
      dateTime.toLocaleDateString() + ' ' + dateTime.toLocaleTimeString();
    let result =
      StringsHelper.getFullName(this.currentUser) +
      ' (' +
      dateTimeString +
      '): ' +
      this.draftMessage +
      '\r\n';
    return result;
  }

  editSubItem(projectControlItem: ProjectControlItem) {
    let config: MatDialogConfig = {
      //      panelClass: 'custom-overlay-pane-class',
      width: '90%',
      height: '90%',
      maxWidth: '90%',
      data: {
        projectControlItem: projectControlItem,
        parentControlItem: this.originalProjectControlItem,
        project: this.project,
        subItems: [],
      },
    };

    const dialogRef = this.dialog.open(ProjectControlItemComponent, config);

    dialogRef.afterClosed().subscribe((result: any) => {
      if (
        result &&
        result.projectControlItemId == projectControlItem.projectControlItemId
      ) {
        this.subItems[this.subItems.indexOf(projectControlItem)] = result;
        this.allSubitemsImplemented = true;
        this.allSubitemsCompleted = true;
        this.subItems.forEach((g) => {
          this.allSubitemsImplemented =
            this.allSubitemsImplemented &&
            g.implementationStatus == ImplementationStatus.Implemented;
          const upcomingDueDate =
            this.getUpcomingDate(g).format('Y-MM-DDT00:00:00');
          this.allSubitemsCompleted =
            this.allSubitemsCompleted &&
            (g.completionPeriods
              .filter((x) => moment(x.dueDate).isSame(upcomingDueDate + 'Z'))
              .map((x) => x.isCompleted)[0] ||
              false);
        });
      }
      this.alertService.clear();
    });
  }
  addIcsSection() {
    const currentCount = parseInt(this.originalProjectControlItem.noOfIcsSections || "1", 10);
    if (currentCount < 3) {
      this.originalProjectControlItem.noOfIcsSections = (currentCount + 1).toString();
    }
  }
  removeIcsSection(i) {
    const currentCount = parseInt(this.originalProjectControlItem.noOfIcsSections || "1", 10);
    this.originalProjectControlItem.noOfIcsSections = (currentCount - 1).toString();
    if (i == 2) {
      this.originalProjectControlItem.newSection2Id = this.originalProjectControlItem.newSection3Id;
      this.visibility.newSection2Edit = this.visibility.newSection3Edit;
      this.originalProjectControlItem.solutionDescription2 = this.originalProjectControlItem.solutionDescription3;
    }
    if (this.originalProjectControlItem.noOfIcsSections === '2') {
      this.originalProjectControlItem.newSection3Id = null;
      this.visibility.newSection3Edit = false;
      this.originalProjectControlItem.solutionDescription3 = null;
    }
    if (this.originalProjectControlItem.noOfIcsSections === '1') {
      this.originalProjectControlItem.newSection2Id = null;
      this.visibility.newSection2Edit = false;
      this.originalProjectControlItem.solutionDescription2 = null;
    }
  }
  onSave(silent: boolean = false) {
    let group;
    if (!this.actionPlanForm.valid) {
      let moved = false;
      const actionPlanForm = <FormArray>(
        this.actionPlanForm.controls['actionPlans']
      );
      for (let a = 0; a < actionPlanForm.length; a++) {
        group = <FormGroup>actionPlanForm.controls[a];
        Object.keys(group.controls).forEach((field) => {
          // {1}
          const control = group.get(field); // {2}
          control.markAsTouched({ onlySelf: false }); // {3}
        });
        if (!actionPlanForm.controls[a].valid && !moved) {
          moved = true;
          document.getElementById('actionPlanBlock' + a).scrollIntoView();
        }
      }
      this.alertService.error(
        'Please fill all required fields in the Action Plan area'
      );
      return;
    }

    if (!this.assessmentNoteForm.valid) {
      const assessmentNoteForm = <FormArray>(
        this.assessmentNoteForm.controls['assessmentNotes']
      );
      for (let a = 0; a < assessmentNoteForm.length; a++) {
        group = <FormGroup>assessmentNoteForm.controls[a];
        Object.keys(group.controls).forEach((field) => {
          // {1}
          const control = group.get(field); // {2}
          control.markAsTouched({ onlySelf: true }); // {3}
        });
      }
      this.alertService.error(
        'Please fill all required fields in the Assessment Note area'
      );
      return;
    }

    this.originalProjectControlItem.organizationalParameters = JSON.stringify(
      this.organizationalParameters
    );
    this.originalProjectControlItem.controlOrigination = JSON.stringify(
      this.controlOrigination
    );
    this.originalProjectControlItem.actionPlans =
      this.actionPlanForm.get('actionPlans').value;
    this.originalProjectControlItem.actionPlans.forEach(
      (p) => (p.type = p.typeBool ? 0 : 1)
    );

    this.originalProjectControlItem.findingsNotes = JSON.stringify(this.originalProjectControlItem.findingsNotesList || []);
    this.originalProjectControlItem.recommendations = JSON.stringify(this.originalProjectControlItem.recommendationsList || []);

    this.originalProjectControlItem.assessmentNotes =
      this.assessmentNoteForm.get('assessmentNotes').value;
    //this.originalProjectControlItem.assessmentNotes.forEach(p => p.type = p.typeBool ? 0: 1);

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    let savingProjectControlItem: ProjectControlItem;

    savingProjectControlItem = Object.assign(
      {},
      this.originalProjectControlItem
    );

    this.loading = true;

    savingProjectControlItem.relatedProjectControlItemIds = (
      this.originalProjectControlItem.relatedProjectControlItems || []
    )
      .map((i) => i.projectControlItemId)
      .join(',');
    savingProjectControlItem.dependencies = (
      this.originalProjectControlItem.dependenciesProjectControlItems || []
    )
      .map((i) => i.projectControlItemId)
      .join(',');

    this.alertService.clear();
    savingProjectControlItem.consultantNotes = this.consultantNotes;
    savingProjectControlItem.clientNotes = this.clientNotes;
    savingProjectControlItem.tenantName = tenantName;
    savingProjectControlItem.evidences =
      this.originalProjectControlItem.evidences;
    savingProjectControlItem.projectControlItemPolicies = [...this.selectedPolicies, ...this.selectedProcedures];
    savingProjectControlItem.completionPeriods =
      this.originalProjectControlItem.completionPeriods.filter(
        (t) => !t.temporary || t.isCompleted
      ); //come on
    savingProjectControlItem.completionPeriods.forEach((p) => {
      p.completedInRizkly = moment(p.completedInRizkly);
      p.actualDate = moment(p.actualDate);
    });

    if (savingProjectControlItem.solutionDescription !== this.data.projectControlItem.solutionDescription) {
      savingProjectControlItem.solutionDescriptionLastUpdated = this.CurrentDate.toISOString();
    }
    if (savingProjectControlItem.solutionDescription2 !== this.data.projectControlItem.solutionDescription2) {
      savingProjectControlItem.solutionDescription2LastUpdated = this.CurrentDate.toISOString();
    }
    if (savingProjectControlItem.solutionDescription3 !== this.data.projectControlItem.solutionDescription3) {
      savingProjectControlItem.solutionDescription3LastUpdated = this.CurrentDate.toISOString();
    }
    savingProjectControlItem.noOfIcsSections = this.originalProjectControlItem.noOfIcsSections;

    savingProjectControlItem.criteriaResults = JSON.stringify(this.criteriaItems.map(i => i.userValue));

    if (this.localDueDate) {
      const d = new Date(this.localDueDate);
      const adjusted = new Date(d.getTime());// - d.getTimezoneOffset() * 60000);
      savingProjectControlItem.dueDate = adjusted;
      //
      console.log("Current local due date", this.localDueDate);
      //console.log("Current project control item due date", this.originalProjectControlItem.dueDate);
      //console.log('Adjusted:', adjusted);
    }


    console.log('savingProjectControlItem dueDate', savingProjectControlItem.dueDate);
    console.log('savingProjectControlItem assessmentDate', savingProjectControlItem.assessmentDate_);
    console.log('savingProjectControlItem completionPeriods', savingProjectControlItem.completionPeriods);

    savingProjectControlItem.solutionDescription = fromByteArray(
      new TextEncoder().encode(

        savingProjectControlItem.solutionDescription || ''
      )
    );
    savingProjectControlItem.solutionDescription2 = fromByteArray(
      new TextEncoder().encode(
        savingProjectControlItem.solutionDescription2 || ''
      )
    );
    savingProjectControlItem.solutionDescription3 = fromByteArray(
      new TextEncoder().encode(
        savingProjectControlItem.solutionDescription3 || ''
      )
    );

    this.projectControlItemService
      .update(
        savingProjectControlItem.projectControlItemId,
        savingProjectControlItem,
      )
      .subscribe(
        (data) => {
          this.loading = false;

          if (!silent) {
            this.alertService.success('The item was updated.', true);

            this.onClose(data);
          }
        },
        (error) => {
          this.loading = false;
          const message = 'An error occurred  while updating item.';
          this.alertService.error(message);
        }
      );
  }

  public DownloadAttachment(fileName: string, isPath: boolean = false) {
    if (isPath && fileName.startsWith('null')) {
      fileName = fileName.substring(4);
    }

    this.fileBlobService
      .downloadFile(
        isPath ? fileName.replace(/^.*[\\\/]/, '') : fileName,
        isPath
          ? fileName.replace(/[^\\/]*$/, '')
          : 'Projects/' +
          this.project.name +
          (this.userMap[this.originalProjectControlItem.assignedClientId]
            .role == Role.Vendor
            ? '/Vendors/' +
            encodeURIComponent(
              this.userMap[
                this.originalProjectControlItem.assignedClientId
              ].emailAddress.replace('@', '_')
            )
            : '') +
          '/Attachments/' +
          this.originalProjectControlItem.shortFolderName
      )
      .subscribe(
        (blob) => {
          importedSaveAs(new Blob([blob]), fileName);
        },
        (error) => {
          const errorMessage =
            error.status == 401
              ? "The logged in user does not have access to the file's location. "
              : 'The referenced file no longer exists in the document library.';
          this.alertService.error(errorMessage);
        }
      );
  }

  public DownloadEvidence(fileName: string, isPath: boolean = false) {
    this.fileBlobService
      .downloadFile(
        isPath ? fileName.replace(/^.*[\\\/]/, '') : fileName,
        isPath
          ? fileName.replace(/[^\\/]*$/, '')
          : 'Projects/' +
          this.project.name +
          (this.userMap[this.originalProjectControlItem.assignedClientId]
            .role == Role.Vendor
            ? '/Vendors/' +
            encodeURIComponent(
              this.userMap[
                this.originalProjectControlItem.assignedClientId
              ].emailAddress.replace('@', '_')
            )
            : '') +
          '/Evidence/' +
          this.originalProjectControlItem.shortFolderName
      )
      .subscribe(
        (blob) => {
          importedSaveAs(new Blob([blob]), fileName);
        },
        (error) => {
          const errorMessage = 'An error occurred while downloading evidence.';
          this.alertService.error(errorMessage);
        }
      );
  }

  public AddAttachment(event) {
    this.originalProjectControlItem.attachments.push(<Attachment>{
      name: '',
      attachmentId: 0,
      editMode: true,
      projectControlItemId:
        this.originalProjectControlItem.projectControlItemId,
      submitterId: this.currentUser.userId,
      date: new Date(),
    });
  }

  public UploadAttachment(event, item) {
    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.fileBlobService
        .postAttachment(
          this.project.name,
          file,
          LoginHelper.getUserId(),
          this.originalProjectControlItem.projectControlItemId.toString()
        )
        .subscribe(
          (res) => {
            item.attachmentId = res.attachmentId;
            item.name = res.name;
            item.internalName = res.internalName;
            item.date = res.date;
            item.projectControlItemId = res.projectControlItemId;
            item.submitterId = res.submitterId;
          },
          (error) => {
            const errorMessage = error.error;
            this.alertService.error(errorMessage);
          }
        );
    }
  }

  public AddEvidence(event) {
    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.fileBlobService
        .postEvidence(
          file,
          LoginHelper.getUserId(),
          this.project.name,
          this.originalProjectControlItem.projectControlItemId.toString()
        )
        .subscribe(
          (res) => {
            this.originalProjectControlItem.evidences.unshift(res);
            this.updateScore();
            this.cdr.detectChanges();
          });
    }
  }

  public addDocument(item) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '80%',
      height: '90%',
      data: {},
    };

    const dialogRef = this.dialog.open(DocumentSelectComponent, config);

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        const url =
          this.config.api +
          '/api/attachments/file?token=' +
          LoginHelper.getFileToken() +
          '&name=' +
          encodeURIComponent(result._orgData.name) +
          '&path=' +
          encodeURIComponent(result._orgData.folderId || '');
        item.url = url;
        item.name =
          'document://' +
          result._orgData.folderId +
          '\\' +
          result._orgData.name;
        item.fileName = result._orgData.name;
      }
    });
  }

  public AddAssessmentAttachment(event, assessmentNote) {
    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.fileBlobService
        .postAssessmentAttachment(
          this.project.name,
          file,
          LoginHelper.getUserId(),
          assessmentNote.value.assessmentNoteId.toString()
        )
        .subscribe(
          (res) => {
            assessmentNote.value.attachments =
              assessmentNote.value.attachments || [];
            assessmentNote.value.attachments.push(res);
          });
    }
  }

  public AddActionPlanAttachment(event, actionPlan) {
    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.fileBlobService
        .postActionPlanAttachment(
          this.project.name,
          file,
          LoginHelper.getUserId(),
          actionPlan.value.actionPlanId.toString()
        )
        .subscribe(
          (res) => {
            actionPlan.value.attachments = actionPlan.value.attachments || [];
            actionPlan.value.attachments.push(res);
          });
    }
  }

  getLevel(fedRAMPRiskExposure: Level) {
    return Level[fedRAMPRiskExposure];
  }

  getDates(projectControlItem: ProjectControlItem): any {
    const dates = DatesHelper.getDates(projectControlItem);
    return dates;
  }

  public isReadOnly(projectControlItem: ProjectControlItem) {
    if (
      ((this.currentUser.role & Role.PrimaryAdvisorLead) |
        Role.PlatformSupport) !=
      0
    )
      return false;

    if (
      this.originalProjectControlItem.sources &&
      this.originalProjectControlItem.sources.find((i) => i.isPrimary)
    ) {
      return true;
    }

    if (
      projectControlItem.recurring == Recurring.None &&
      projectControlItem.reviewedByConsultant
    ) {
      return (
        (this.currentUser.role &
          (Role.AdvisorLead |
            Role.PrimaryAdvisorLead |
            Role.PlatformSupport)) ==
        0 &&
        (this.currentUser.role & (Role.Manager | Role.PrimaryManager)) == 0
      );
    }

    if (
      this.currentUser.userId ==
      this.originalProjectControlItem.assignedClientId
    ) {
      return false;
    }

    if (this.isNotConsultant && !this.isManager) {
      return true;
    }

    return false;
  }

  public isReadOnlyOrManager(projectControlItem: ProjectControlItem) {
    if (
      (this.currentUser.role &
        (Role.PrimaryAdvisorLead | Role.PlatformSupport)) !=
      0
    )
      return false;

    if (
      this.originalProjectControlItem.sources &&
      this.originalProjectControlItem.sources.find((i) => i.isPrimary)
    ) {
      return true;
    }

    if (
      projectControlItem.recurring == Recurring.None &&
      projectControlItem.reviewedByConsultant
    ) {
      return (
        (this.currentUser.role &
          (Role.AdvisorLead |
            Role.PrimaryAdvisorLead |
            Role.PlatformSupport)) ==
        0 &&
        (this.currentUser.role & (Role.Manager | Role.PrimaryManager)) == 0
      );
    }

    if (
      this.isNotConsultant &&
      (this.currentUser.role & (Role.Manager | Role.PrimaryManager)) == 0
    ) {
      return true;
    }

    return false;
  }

  addRelated() {
    let config = {
      panelClass: 'custom-overlay-pane-class',
      width: 'auto',
      height: '600px',

      data: {},
    };

    this.controlItemDialogRef = this.dialogService.open(
      SelectProjectControlItemComponent,
      config
    );

    this.controlItemDialogRef.onClose.subscribe((result: any) => {
      this.originalProjectControlItem.relatedProjectControlItems.push(result);
    });
  }

  addDependency() {
    let config = {
      panelClass: 'custom-overlay-pane-class',
      width: 'auto',
      height: '600px',

      data: {},
    };

    this.controlItemDialogRef = this.dialogService.open(
      SelectProjectControlItemComponent,
      config
    );

    this.controlItemDialogRef.onClose.subscribe((result: any) => {
      this.originalProjectControlItem.dependenciesProjectControlItems.push(
        result
      );
    });
  }

  addSource() {
    this.router.navigate([
      '/projects/project',
      this.originalProjectControlItem.projectId,
      'mapControlItems',
    ]);
    this.onClose(null);
  }

  removeProjectControlItem(item, e) {
    this.originalProjectControlItem.relatedProjectControlItems.splice(
      this.originalProjectControlItem.relatedProjectControlItems.indexOf(item),
      1
    );
    e.preventDefault();
  }

  removeDependencyProjectControlItem(item, e) {
    this.originalProjectControlItem.dependenciesProjectControlItems.splice(
      this.originalProjectControlItem.dependenciesProjectControlItems.indexOf(
        item
      ),
      1
    );
    e.preventDefault();
  }

  onDueDateChange(event: any) {
    if (!event.value) return;

    this.localDueDate = event.value;

    const utcDate = new Date(Date.UTC(
      this.localDueDate.getFullYear(),
      this.localDueDate.getMonth(),
      this.localDueDate.getDate()
    ));

    this.originalProjectControlItem.dueDate = utcDate;

    console.log("Current local due date", this.localDueDate);
    console.log("Current project control item due date", this.originalProjectControlItem.dueDate);
  }


  onDueDateChanged(event) {
    let originalDueDate = this.originalProjectControlItem.dueDate;
    const newDate = new Date(event.value);
    const oldRanges = DatesHelper.getDates(
      this.originalProjectControlItem,
      moment(event.value),
      moment(this.prevDate)
    );
    const now = moment();

    this.prevDate = this.originalProjectControlItem.dueDate;
    this.originalProjectControlItem.dueDate = newDate;
    const newRanges = DatesHelper.getDates(
      this.originalProjectControlItem,
      moment(event.value)
    );

    const futureOldRanges = oldRanges.filter(
      (r) =>
        r.date.isAfter(now) && !newRanges.find((n) => n.date.isSame(r.date))
    );

    const dropFuture =
      futureOldRanges.length &&
      confirm(
        'Do you want to drop the existing scheduled completion(s) on ' +
        futureOldRanges.map((r) => r.date.format('l')).join(', ') +
        '?'
      );

    const newPeriods = newRanges
      .concat(
        oldRanges.filter(
          (r) =>
            !newRanges.find((n) => n.value == r.value) &&
            (!dropFuture || r.date.isBefore(now))
        )
      )
      .sort((a, b) => (a.value > b.value ? -1 : 1))
      .map((r) => {
        const existing = this.originalProjectControlItem.completionPeriods.find(
          (i) =>
            moment(
              moment.utc(i.dueDate).format('Y-MM-DDT00:00:00') + 'Z'
            ).isSame(r.value + 'Z')
        );
        if (existing) return existing;
        return {
          dueDate: r.value,
          completionPeriodId: 0,
          projectControlItemId:
            this.originalProjectControlItem.projectControlItemId,
          note: null,
          completedInRizkly: null,
          temporary: false,
          isCompleted: false,
          actualDate: null,
        };
      });
    //var preservedPeriods = this.originalProjectControlItem.completionPeriods.filter(r => !r.temporary && (!dropFuture || moment(r.dueDate).isBefore(now)));
    this.originalProjectControlItem.completionPeriods = newPeriods; //preservedPeriods.filter(p => !newPeriods.find(n => p.completionPeriodId == n.completionPeriodId)).concat(newPeriods)
    this.originalProjectControlItem.dueDate = newDate;

    const dates = DatesHelper.getDates(this.originalProjectControlItem);
    this.originalProjectControlItem.upcomingDueDate = this.getUpcomingDate(
      this.originalProjectControlItem
    ).format('Y-MM-DDT00:00:00');
    this.completionPeriodChange(
      this.originalProjectControlItem.completionPeriods.find((t) =>
        moment(moment.utc(t.dueDate).format('Y-MM-DDT00:00:00') + 'Z').isSame(
          this.originalProjectControlItem.upcomingDueDate + 'Z'
        )
      ) || {
        actualDate: null,
        isCompleted: false,
        temporary: false,
        completedInRizkly: null,
        completionPeriodId: 0,
        projectControlItemId: this.projectControlItem.projectControlItemId,
        dueDate: this.originalProjectControlItem.upcomingDueDate,
        note: '',
      }
    );
  }
  onAssessmentDateChanged(event) {
    const selectedDate = new Date(event.value);
    const formattedDate = new Date(
      selectedDate.getFullYear(),
      selectedDate.getMonth(),
      selectedDate.getDate(),
      19,
      0,
      0
    );
    const isoString = formattedDate.toISOString().slice(0, 19);
    this.originalProjectControlItem.assessmentDate_ = isoString;
  }
  lastDate() {
    return this.getUpcomingDate(this.originalProjectControlItem).format(
      'MM/DD/Y'
    );
  }

  completedChanged(event) {
    /*if (event.checked)
    {
      this.originalProjectControlItem.completedDates  = [moment(this.originalProjectControlItem.dueDate).format('Y-MM-DDT00:00:00'), 'empty'];
    }
    else
    {
      this.originalProjectControlItem.completedDates = ['empty']
    }*/
  }

  stop(event) {
    event.stopPropagation();
  }

  actualCompletedDateClicked(event) {
    if (
      !this.selectedCompletionPeriod.actualDate &&
      this.selectedCompletionPeriod.isCompleted
    ) {
      this.selectedCompletionPeriod.actualDate = new Date();
    }
    event.stopPropagation();
  }

  onActualDateChanged(event: any) {
    if (this.selectedCompletionPeriod) {
      this.selectedCompletionPeriod.actualDate = event.value;
      this.selectedCompletionPeriod.isCompleted = !!event.value;
    }
    console.log("actual date changed to " + event.value + " for " + JSON.stringify(this.selectedCompletionPeriod));
  }

  public getUpcomingDate(projectControlItem): moment.Moment {
    const ranges = DatesHelper.getDates(projectControlItem);
    const now = moment().startOf('day');
    const closest = ranges
      .reverse()
      .find((i) => i.date.isSameOrAfter(now, 'day'));
    return (closest || ranges[0]).date; //DOTO :: Why so ofte
  }

  upcomingCompletedChanged(event) {
    const upcoming = this.getUpcomingDate(this.originalProjectControlItem);
    let upcomingPeriod = this.originalProjectControlItem.completionPeriods.find(
      (d) =>
        moment(moment.utc(d.dueDate).format('Y-MM-DDT00:00:00') + 'Z').isSame(
          upcoming + 'Z'
        )
    );
    if (upcomingPeriod == null) {
      upcomingPeriod = {
        isCompleted: event.checked,
        dueDate: upcoming,
        actualDate: moment(),
        completedInRizkly: null,
        completionPeriodId: 0,
        note: '',
        projectControlItemId: this.projectControlItem.projectControlItemId,
      };
      this.originalProjectControlItem.completionPeriods.push(upcomingPeriod);
    }
    upcomingPeriod.isCompleted = event.checked;
  }

  completedChange() { }

  formatDate(date) {
    return moment(date).format('MM/DD/YYYY');
  }

  addPlan() {
    this.addActionPlanGroup(
      {
        name: null,
        weaknessDescription: null,
        identificationDate: null,
        scheduledCompletionDate: null,
        actualCompletionDate: null,
        remediationPlansActionsMilestones: null,
        changesToRemediationPlansActionsMilestones: null,
        comments: null,
        responsibleParty: null,
        howIdentified: null,
        currentStatus: null,
        actionPlanId: null,
        pOAMId: null,
        projectControlItemId: null,
        typeBool: true,
        createIncidentResponse: false,
        modifiedDate: null,
        assessmentNoteIds: '',
        assessmentNotes: [],
        actionPlanTemplateId: null,
        impactedControls: '',
        topic: '',
        loe: 0,
        requirementOrGuidance: '',
        affectedSystems: '',
        source: 'Created Manually',
        system: '',
        number:
          Math.max.apply(
            null,
            (<any>this.actionPlanForm.controls.actionPlans).controls.map(
              (a) => a.value.number
            )
          ) + 10,
      },
      true
    );
  }

  removeActionPlan(index) {
    (<FormArray>this.actionPlanForm.controls['actionPlans']).removeAt(index);
    this.updateScore();
  }

  addAssessmentNoteGroup(model: AssessmentNote, visible: boolean = false) {
    const group = this.formBuilder.group({
      assessmentNoteId: [null],
      attachments: [[]],
      assessmentMethod: ['', [Validators.required]],
      assessmentResults: [null],
      finding: [''],
      recommendations: [''],
      name: ['', [Validators.required]],
      title: [''],
      date: [null, [Validators.required]],
      isVisible: [true],
      projectControlItemId: [null],
      isVisibleInSsp: [false],
      isThirdParty: [false],
      status: [0],
      peopleInterviewed: [''],
      interviewDate: [null]
    });
    (<FormArray>this.assessmentNoteForm.controls['assessmentNotes']).push(
      group
    );
    // @ts-ignore
    group.setValue({
      assessmentNoteId: 0,
      projectControlItemId: this.projectControlItem.projectControlItemId,
      assessmentResults: '',
      finding: null,
      recommendations: '',
      name: '',
      title: '',
      isVisibleInSsp: true,
      status: 0,
      peopleInterviewed: '',
      interviewDate: null,
      ...model
    });
    //console.log((<FormArray>this.assessmentNoteForm.controls['assessmenNotes']).length - 1);
  }

  addAssessment() {
    this.addAssessmentNoteGroup(
      {
        assessmentNoteId: 0,
        projectControlItemId: this.projectControlItem.projectControlItemId,
        assessmentMethod: '',
        assessmentResults: '',
        finding: '',
        recommendations: '',
        name: '',
        title: '',
        date: null,
        attachments: [],
        isVisibleInSsp: true,
        status: 0,
        peopleInterviewed: '',
        interviewDate: null
      },
      true
    );
  }

  removeAssessmentNote(index) {
    (<FormArray>this.assessmentNoteForm.controls['assessmentNotes']).removeAt(
      index
    );
  }

  updateRowGroupMetaData() {
    this.subItems = this.subItems || [];
    this.subItems = this.subItems.sort((a, b) =>
      a.controlItem.level > b.controlItem.level
        ? 1
        : a.controlItem.level < b.controlItem.level
          ? -1
          : a.controlItem.description > b.controlItem.description
            ? 1
            : -1
    );

    this.rowGroupMetadata = {};
    if (this.subItems) {
      let i;
      this.subitemSummary = [];
      for (let i = 0; i < this.subItems.length; i++) {
        let rowData = this.subItems[i];
        let brand = rowData.controlItem.level;

        let levelItem = this.subitemSummary.find(
          (i) => i.level == rowData.controlItem.level
        );
        if (!levelItem) {
          levelItem = {
            completed: 0,
            level: rowData.controlItem.level,
            percent: 0,
            total: 0,
          };
          this.subitemSummary.push(levelItem);
        }
        levelItem.total++;
        if (
          (rowData.recurring == Recurring.None &&
            rowData.completionPeriods.find((p) => p.isCompleted)) ||
          rowData.completionPeriods.find(
            (p) =>
              moment(p.dueDate).isSameOrAfter(moment(), 'day') && p.isCompleted
          )
        ) {
          levelItem.completed++;
        }
        levelItem.percent = Math.round(
          (levelItem.completed / levelItem.total) * 100
        );

        /*for (var j = 0; j < this.defaultGroups.length; j++)
        {
          if (this.defaultGroups[j] == brand)
          {
            break;
          }
          if (!this.rowGroupMetadata[this.defaultGroups[j]])
          {
            this.rowGroupMetadata[this.defaultGroups[j]] = {index: i, size: 0};
          }
        }*/
        if (i == 0) {
          this.rowGroupMetadata[brand] = { index: 0, size: 1 };
        } else {
          let previousRowData = this.subItems[i - 1];
          let previousRowGroup = previousRowData.controlItem.level;
          if (brand === previousRowGroup) this.rowGroupMetadata[brand].size++;
          else this.rowGroupMetadata[brand] = { index: i, size: 1 };
        }
      }
      this.levelReached = null;
      for (i = 0; i < this.subitemSummary.length; i++) {
        if (this.subitemSummary[i].percent == 100) {
          this.levelReached = this.subitemSummary[i].level;
        } else {
          break;
        }
      }
    }
  }

  addPolicy(kind: number) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: 'auto',
      height: '600px',

      data: {
        policies: this.policies.filter(
          (p) => !this.selectedPolicies.find(a => a.policy == p) && !this.selectedProcedures.find(a => a.policy == p)
        ),
        controlItemId:
          this.originalProjectControlItem.controlItem.controlItemId,
      },
    };

    this.selectPolicyDialogRef = this.dialog.open(
      SelectPolicyComponent,
      config
    );

    this.selectPolicyDialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        (kind == 0 ? this.selectedPolicies : this.selectedProcedures).push({ policy: result, policyId: result.id, projectControlItemId: this.originalProjectControlItem.projectControlItemId, kind });
        this.updatePolicyMappings();
        this.updateScore();
        this.cdr.detectChanges();
      }
    });
  }

  selectImplementationControlStatement() {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: 'auto',
      height: '600px',

      data: {
        implementationControlStatementSets: this.implementationControlStatementSets,
      },
    };

    this.selectImplementationControlStatementDialogRef = this.dialog.open(
      SelectImplementationControlStatementComponent,
      config
    );

    this.selectImplementationControlStatementDialogRef
      .afterClosed()
      .subscribe((result: any) => {
        if (result) {
          this.originalProjectControlItem.solutionDescription = result.text;
          this.originalProjectControlItem.solutionDescription2 = result.text;
          this.originalProjectControlItem.solutionDescription3 = result.text;
          this.updateScore();
          this.cdr.detectChanges();
        }
      });
  }

  selectImplementationControlStatementForLink() {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: 'auto',
      height: '600px',

      data: {
        implementationControlStatementSets: this.implementationControlStatementSets,
      },
    };

    this.selectImplementationControlStatementDialogRef = this.dialog.open(
      SelectImplementationControlStatementComponent,
      config
    );

    this.selectImplementationControlStatementDialogRef
      .afterClosed()
      .subscribe((result: any) => {
        if (result) {
          this.originalProjectControlItem.implementationControlStatementId =
            result.id;
          this.linkedImplementationControlStatement = result.text;
        }
      });
  }

  loadActionPlanTemplates() {
    this.actionPlanTemplateService
      .getActionItemsForProject(this.originalProjectControlItem.projectId)
      .subscribe((p) => {
        this.actionPlanTemplates = p.filter(b => this.project.actionPlanTemplateSetIds.indexOf(b.actionPlanTemplateSetId) >= 0);
        this.actionPlanTemplates.forEach(
          (b) => (this.actionPlanTemplatesMap[b.actionPlanTemplateId] = b)
        );
      });
  }

  addActionPlanTemplate(isLink: boolean) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: 'auto',
      height: '600px',

      data: {
        actionPlanTemplates: this.actionPlanTemplates,
        isLink: isLink,
      },
    };

    this.selectActionPlanTemplateDialogRef = this.dialog.open(
      SelectActionPlanTemplateComponent,
      config
    );

    this.selectActionPlanTemplateDialogRef
      .afterClosed()
      .subscribe((result: any) => {
        if (result) {
          this.addActionPlanGroup(
            {
              name: result.name,
              weaknessDescription: result.weaknessDescription,
              identificationDate: result.identificationDate,
              scheduledCompletionDate: result.scheduledCompletionDate,
              actualCompletionDate: result.actualCompletionDate,
              remediationPlansActionsMilestones:
                result.remediationPlansActionsMilestones,
              changesToRemediationPlansActionsMilestones:
                result.changesToRemediationPlansActionsMilestones,
              comments: result.comments,
              riskLevel: result.riskLevel || '',
              responsibleParty: result.responsibleParty,
              howIdentified: result.howIdentified || '',
              topic: result.topic || '',
              loe: result.loe || '',
              requirementOrGuidance: result.requirementOrGuidance || '',
              currentStatus: result.currentStatus,
              actionPlanId: null,
              pOAMId: result.poamId,
              projectControlItemId: null,
              typeBool: result.type == 1,
              createIncidentResponse: false,
              modifiedDate: null,
              assessmentNoteIds: '',
              assessmentNotes: [],
              actionPlanTemplateId: isLink ? result.actionPlanTemplateId : null,
              impactedControls: '',
              number:
                Math.max.apply(
                  null,
                  (<any>this.actionPlanForm.controls.actionPlans).controls.map(
                    (a) => a.value.number
                  )
                ) + 10,
              attachments: [],
            },
            true
          );
        }
      });
  }

  removePolicy(i, kind) {
    if (kind === 0) {
      this.selectedPolicies = this.selectedPolicies.filter((c) => c != i);
    }
    else {
      this.selectedProcedures = this.selectedProcedures.filter((c) => c != i);
    }
    this.updateScore();
  }

  saveEvidence(item, approved) {
    if (approved !== null) {
      item.isApproved = approved;
    }
    if (item.name.startsWith('external://')) {
      item.name = 'external://' + item.externalName;
    }
    this.fileBlobService.updateEvidence(item).subscribe(
      (res: any) => {
        item.endDate = res.endDate;
        item.evidenceId = res.evidenceId;
      },
      (error) => {
        const errorMessage = 'An error occurred while updating evidence.';
        this.alertService.error(errorMessage);
      }
    );
    this.updateScore();
  }

  saveAttachment(item) {
    this.fileBlobService.updateAttachment(item).subscribe(
      (res) => { },
      (error) => {
        const errorMessage = 'An error occurred while updating evidence.';
        this.alertService.error(errorMessage);
      }
    );
  }

  saveAssessmentAttachment(item) {
    this.fileBlobService.updateAssessmentAttachment(item).subscribe(
      (res) => { },
      (error) => {
        const errorMessage = 'An error occurred while updating evidence.';
        this.alertService.error(errorMessage);
      }
    );
  }
  saveActionPlanAttachment(item) {
    this.fileBlobService.updateActionPlanAttachment(item).subscribe(
      (res) => { },
      (error) => {
        const errorMessage = 'An error occurred while updating evidence.';
        this.alertService.error(errorMessage);
      }
    );
  }

  deleteEvidence(item) {
    if (item.evidenceId === 0) {
      this.originalProjectControlItem.evidences.splice(
        this.originalProjectControlItem.evidences.indexOf(item),
        1
      );
    } else {
      this.fileBlobService.deleteEvidence(item.evidenceId).subscribe(
        (res) => {
          this.originalProjectControlItem.evidences.splice(
            this.originalProjectControlItem.evidences.indexOf(item),
            1
          );
        },
        (error) => {
          const errorMessage = 'An error occurred while deleting evidence.';
          this.alertService.error(errorMessage);
        }
      );
    }
    this.updateScore();
  }

  deleteAttachment(item) {
    this.fileBlobService.deleteAttachment(item.attachmentId).subscribe(
      (res) => {
        this.originalProjectControlItem.attachments.splice(
          this.originalProjectControlItem.attachments.indexOf(item),
          1
        );
      },
      (error) => {
        const errorMessage = 'An error occurred while deleting attachment.';
        this.alertService.error(errorMessage);
      }
    );
  }

  deleteAssessmentAttachment(assessmentNote, item) {
    this.fileBlobService
      .deleteAssessmentAttachment(item.attachmentId)
      .subscribe(
        (res) => {
          assessmentNote.value.attachments.splice(
            assessmentNote.value.attachments.indexOf(item),
            1
          );
        },
        (error) => {
          const errorMessage = 'An error occurred while deleting attachment.';
          this.alertService.error(errorMessage);
        }
      );
  }

  deleteActionPlanAttachment(actionPlan, item) {
    this.fileBlobService
      .deleteActionPlanAttachment(item.actionPlanAttachmentId)
      .subscribe(
        (res) => {
          actionPlan.value.attachments.splice(
            actionPlan.value.attachments.indexOf(item),
            1
          );
        },
        (error) => {
          const errorMessage = 'An error occurred while deleting attachment.';
          this.alertService.error(errorMessage);
        }
      );
  }

  addLinkEvidence() {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: 'auto',
      height: 'auto',
    };

    const dialogRef = this.dialog.open(AddUrlComponent, config);

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result.url) {
        this.fileBlobService
          .createEvidence({
            name: result.url,
            projectControlItemId:
              this.originalProjectControlItem.projectControlItemId,
            submitterId: LoginHelper.getUserId(),
            evidenceId: 0,
            date: new Date(),
          })
          .subscribe(
            (res) => {
              this.originalProjectControlItem.evidences.push(res);
            },
            (error) => {
              const errorMessage = 'An error occurred while creati evidence.';
              this.alertService.error(errorMessage);
            }
          );
      }
    });
  }
  //manulal upload
  addExternalEvidence() {
    (<any[]>this.originalProjectControlItem.evidences).push({
      name: 'external://',
      externalName: 'Evidence Collected Elsewhere',
      projectControlItemId:
        this.originalProjectControlItem.projectControlItemId,
      submitterId: LoginHelper.getUserId(),
      evidenceId: 0,
      date: new Date(),
      editMode: true,
    });
  }

  completionPeriodChange(completionPeriod) {
    //    this.upcomingDate = this.selectedCompletionPeriod.dueDate;
    this.selectedCompletionPeriod = completionPeriod;
    if (completionPeriod?.isCustom) {
      this.upcomingDate = null;
    } else {
      if (completionPeriod) {
        setTimeout(() => {
          this.upcomingDate = completionPeriod.dueDate;
        }, 200); //no-no-no
      }
    }
  }

  selectDocument(node) {
    const q = window['quill'];

    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '80%',
      height: '90%',
      data: {},
    };

    const dialogRef = this.dialog.open(DocumentSelectComponent, config);

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        const quill = window['quills'].find(
          (q) =>
            q.container ===
            node.closest('.p-editor-container').querySelector('.ql-container')
        );
        const url =
          this.config.api +
          '/api/attachments/file?name=' +
          encodeURIComponent(result._orgData.name) +
          '&path=' +
          (result._orgData.folderId || '');
        quill.format('link', url, 'user');
      }
    });
  }

  a(a) {
    debugger;
  }

  addToken(html) {
    return html
      ? html.replace(
        /api\/attachments\/file\?/gi,
        'api/attachments/file?token=' + LoginHelper.getFileToken() + '&'
      )
      : html;
  }

  openLinked(id) {
    this.projectControlItemService.getById(id).subscribe((i) => {
      let config: MatDialogConfig = {
        panelClass: 'custom-overlay-pane-class',
        width: '90%',
        height: '90%',
        maxWidth: '90%',
        data: {
          projectControlItem: i,
          parentControlItem: this.originalProjectControlItem,
          project: this.project,
          subItems: [],
        },
      };

      const dialogRef = this.dialog.open(ProjectControlItemComponent, config);

      dialogRef.afterClosed().subscribe((result: any) => {
        this.alertService.clear();
      });
    });
  }

  setRelatedAssesssmentNotes(item, $event) {
    item.controls.assessmentNoteIds.setValue(
      $event.value.map((v) => v.assessmentNoteId).join(',')
    );
  }

  createActionPlanTemplate(actionItemForm) {
    const savingObject = Object.assign({}, actionItemForm.value);
    savingObject.actionItemTemplateId = null;

    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      data: {
        categories: this.actionPlanTemplates
          .map((t) => t.category)
          .filter((v, i, a) => a.indexOf(v) == i),
      },
    };

    const dialogRef = this.dialog.open(CreatePoamTemplateComponent, config);

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        savingObject.category = result.category;
        savingObject.name = result.name;
        if (result.isGlobal) {
          savingObject.projectId = null;
        }
        this.actionPlanTemplateService
          .saveActionItem(savingObject)
          .subscribe((actionTemplateId) => {
            actionItemForm.value.actionPlanTemplateId = actionTemplateId;
            actionItemForm.setValue(actionItemForm.value);
            this.loadActionPlanTemplates();
          });
      }
    });
  }

  loadDictionaries() {
    this.dictionaryService.get(['Vendor', 'Service']).subscribe((r) => {
      this.vendors = r.filter((r) => r.dictionary == 'Vendor');
      this.services = r.filter((r) => r.dictionary == 'Service');
      this.services.forEach(
        (r) =>
        ((<any>r).vendor = (
          this.vendors.find((v) => v.itemId == r.parentId) || {}
        ).name)
      );
      this.potentialRecommendedSolutions = this.services.filter(s => s.dictionaryControlItems.find(j => j.controlItemId === this.originalProjectControlItem.controlItemId));
      this.potentialRecommendedSolutions.forEach(s => {
        s.logoUrl = '/api/attachments/file?name=' + encodeURIComponent(s.listLogoFileName) + '&path=Account/Dictionaries/' + '&token=' + LoginHelper.getFileToken();
      });
      (this.originalProjectControlItem.sharedResponsibilities || []).forEach(
        (i) =>
        (i.service = this.services.find(
          (s) => s.itemId == i.dictionaryItemId
        ))
      );
      this.vendorChanged();
      if (this.loadingCounter > 0) {
        this.loadingCounter--;
      }
    });
  }

  vendorChanged() {
    const vendor = this.vendors.find(
      (v) => v.itemId == this.sharedResponsibilityForm.controls.vendorId.value
    );
    const currentServices = vendor
      ? this.services.filter((s) => s.parentId == vendor.itemId)
      : [];
    this.securityTopics = currentServices.filter((s, i) => currentServices.indexOf(s) == i).map(s => s.securityTopic);
  }

  topicChanged() {
    const vendor = this.vendors.find(
      (v) => v.itemId == this.sharedResponsibilityForm.controls.vendorId.value
    );
    const topic = this.sharedResponsibilityForm.controls.securityTopic.value;
    this.filteredServices = vendor
      ? this.services.filter((s) => s.parentId == vendor.itemId && s.securityTopic == topic)
      : [];
  }

  serviceChanged() {
    const service = this.filteredServices.find(s => s.itemId === this.sharedResponsibilityForm.controls.serviceId.value);
    if (service) {
      this.sharedResponsibilityForm.controls.responsibility.setValue(service.inheritance);
    }
  }

  addVendor() {
    const dialogRef = this.dialog.open(PromptComponent, {
      data: {
        title: 'Add Vendor',
      },
    });

    dialogRef.afterClosed().subscribe((r) => {
      if (!r) {
        return;
      }
      this.dictionaryService
        .save({
          name: r,
          dictionary: 'Vendor',
        })
        .subscribe((r) => {
          this.loadDictionaries();
          this.sharedResponsibilityForm.controls.vendorId.setValue(r.itemId);
        });
    });
  }

  addService() {
    const dialogRef = this.dialog.open(PromptComponent, {
      data: {
        title: 'Add Solution',
      },
    });

    dialogRef.afterClosed().subscribe((r) => {
      if (!r) {
        return;
      }
      this.dictionaryService
        .save({
          name: r,
          dictionary: 'Service',
          parentId: this.vendors.find(
            (v) =>
              v.itemId == this.sharedResponsibilityForm.controls.vendorId.value
          ).itemId,
        })
        .subscribe(() => {
          this.loadDictionaries();
        });
    });
  }

  addServiceToList() {
    if (!this.sharedResponsibilityForm.valid) {
      Object.keys(this.sharedResponsibilityForm.controls).forEach((field) => {
        const control = this.sharedResponsibilityForm.get(field);
        control.markAsTouched({ onlySelf: true });
      });
      return;
    }
    this.originalProjectControlItem.sharedResponsibilities =
      this.originalProjectControlItem.sharedResponsibilities || [];
    this.originalProjectControlItem.sharedResponsibilities =
      this.originalProjectControlItem.sharedResponsibilities.filter(
        (s) =>
          s.dictionaryItemId !=
          this.sharedResponsibilityForm.controls.serviceId.value
      );
    const service = this.services.find(
      (s) => s.itemId == this.sharedResponsibilityForm.controls.serviceId.value
    );
    this.originalProjectControlItem.sharedResponsibilities.push({
      dictionaryItemId: this.sharedResponsibilityForm.controls.serviceId.value,
      responsibility:
        this.sharedResponsibilityForm.controls.responsibility.value,
      service: service,
      contacts: this.sharedResponsibilityForm.controls.contacts.value,
      projectControlItemId:
        this.originalProjectControlItem.projectControlItemId,
    });
    this.sharedResponsibilityForm.setValue({
      responsibility: null,
      vendorId: null,
      serviceId: null,
      securityTopic: null,
      contacts: '',
      elixir: '',
    });
    this.isResponsibilityEdit = false;
  }

  editSharedResponsibility(sharedResponsibility) {
    this.sharedResponsibilityForm.setValue({
      responsibility: sharedResponsibility.responsibility,
      vendorId: sharedResponsibility.service.parentId,
      serviceId: sharedResponsibility.dictionaryItemId,
      securityTopic: sharedResponsibility.service.securityTopic,
      contacts: sharedResponsibility.contacts,
      elixir: sharedResponsibility.elixir,
    });
    this.vendorChanged();
    this.isResponsibilityEdit = true;
    //setTimeout(() => this.editSharedResponsibility(sharedResponsibility), 0);
  }

  deleteSharedResponsibility(sharedResponsibility) {
    this.originalProjectControlItem.sharedResponsibilities =
      this.originalProjectControlItem.sharedResponsibilities.filter(
        (r) => r != sharedResponsibility
      );
  }

  updatePolicyMappings() {
    this.policies.forEach((p) => {
      (<any>p).popupControlMap = p.policySections.filter(
        (s) =>
          (',' + s.controlIds + ',').indexOf(
            ',' +
            this.originalProjectControlItem.controlItem.controlItemId +
            ','
          ) >= 0
      );
      (<any>p).isMapped =
        (',' + p.controlIds + ',').indexOf(
          ',' + this.originalProjectControlItem.controlItem.controlItemId + ','
        ) >= 0;
    });
  }

  openEvidenceArchive() {
    this.onClose(this.originalProjectControlItem);
    this.router.navigate(['/documents/archive', this.originalProjectControlItem.projectId]);
  }

  implementationStatusChanged(e) {
    if (e.value === ImplementationStatus.None) {
      this.originalProjectControlItem.score =
        this.originalProjectControlItem.controlItem.value;
    }
    if (
      e.value === ImplementationStatus.NotApplicable ||
      e.value === ImplementationStatus.Implemented
    ) {
      this.originalProjectControlItem.score = 0;
    }
  }


  async generateGuidance(service: any): Promise<string> {
    if (!service) {
      console.log('Generate guidance called with null service');
      return '';
    }

    const now = Date.now();
    if (this.lastGuidanceRequest[service.itemId] &&
      (now - this.lastGuidanceRequest[service.itemId]) < this.GUIDANCE_COOLDOWN_MS) {
      console.log(`Guidance generation throttled for service ${service.itemId}. Please wait.`);
      this.alertService.error('Please wait a moment before generating another guidance.');
      return '';
    }

    if (this.guidanceDebounceTimeout) {
      clearTimeout(this.guidanceDebounceTimeout);
    }

    return new Promise((resolve) => {
      this.guidanceDebounceTimeout = setTimeout(() => {

        this.userService.getCurrent().subscribe({
          next: async (user: any) => {
            const vendor = service.vendor || '';
            const topic = service.securityTopic || '';
            const solutionName = service.name || '';
            const requirement = (this.originalProjectControlItem?.controlItem?.complianceAreaName + ' ' + this.originalProjectControlItem?.controlItem?.name) || '';
            const profile = this.clientProfile[0] || {};
            const deploymentType = profile.deploymentType || '';
            const primaryOS = profile.primaryOS || '';
            const idMgmtProduct = profile.identityManagement || '';
            const primaryFirewallProd = profile.firewallProduct || '';
            const primaryConfigMgmtProduct = profile.configManagementProduct || '';
            const primaryDevLang = profile.devLanguage || '';
            const securityToolsDeployed = profile.securityTools || '';
            const otherKeyTech = profile.otherTech1 || '';

            const input = {
              vendor,
              topic,
              solutionName,
              requirement,
              deploymentType,
              primaryOS,
              idMgmtProduct,
              primaryFirewallProd,
              primaryConfigMgmtProduct,
              primaryDevLang,
              securityToolsDeployed,
              otherKeyTech,
            };

            const prompt = `Please provide in-depth, detailed, step-by-step instructions for configuring ${input.vendor} for ${input.topic} to satisfy ${input.solutionName} for ${input.requirement}. Give the estimated amount of time it takes to implement. Do not provide any comments other than the guidance. Start your response with 1. and finish it with the last point.
          These are my specific details:
          - Deployment Type: ${input.deploymentType}
          - Primary OS: ${input.primaryOS}
          - Identity Management Product: ${input.idMgmtProduct}
          - Primary Firewall Product: ${input.primaryFirewallProd}
          - Primary Configuration Management Product: ${input.primaryConfigMgmtProduct}
          - Primary Development Language: ${input.primaryDevLang}
          - Security Tools Deployed: ${input.securityToolsDeployed}
          - Other Key Technologies: ${input.otherKeyTech}`;

            if (!this.guidanceLoading[service.itemId]) {
              this.guidanceLoading[service.itemId] = true;
              this.cdr.detectChanges();

              let rawOutput = '';
              let errorMessage = '';
              let outputSet = false;

              try {

                const activeProvider = user.llmProviders?.find((p: any) => p.isActive);
                if (!activeProvider || !activeProvider.encryptedApiKey) {
                  this.alertService.error('No active LLM provider found. Please fill in this information under LLM Blockchain in Account Profile.');
                  throw new Error('No active LLM provider/api key found.');
                }
                const api_key = EncryptHelper.decrypt(activeProvider.encryptedApiKey);
                const providerName = activeProvider.provider?.toLowerCase() || '';
                let [provider, ...rest] = providerName.toLowerCase().split('-');
                let model = rest.join("-");

                const data = await this.callProvider(provider, providerName, model, api_key, prompt);
                rawOutput = JSON.stringify(data);

                if (data?.choices?.[0]?.message?.content) {
                  const content = data.choices[0].message.content.trim();
                  this.guidanceOutputs[service.itemId] = content.replace(/\n/g, '<br>');
                  outputSet = true;
                  this.lastGuidanceRequest[service.itemId] = Date.now();
                  resolve(this.guidanceOutputs[service.itemId]);
                } else {
                  errorMessage = 'No valid content returned from LLM.';
                  throw new Error(errorMessage);
                }
              } catch (e: any) {
                errorMessage = e?.message || 'Unknown error';
                console.error('Error generating guidance:', errorMessage, 'Raw output:', rawOutput);

                setTimeout(() => {
                  this.guidanceOutputs[service.itemId] =
                    `Failed to generate guidance.<br><br><b>Raw LLM output:</b><br><pre>${rawOutput || '[none]'}</pre>`;
                  this.alertService.error(`Error generating guidance: ${errorMessage}<br><pre>${rawOutput || '[none]'}</pre>`);
                  this.guidanceLoading[service.itemId] = false;
                  this.cdr.detectChanges();
                  resolve(this.guidanceOutputs[service.itemId]);
                }, 3000);
              } finally {
                if (outputSet) {
                  this.guidanceLoading[service.itemId] = false;
                  this.cdr.detectChanges();
                }
              }
            } else {
              console.log('Guidance generation already in progress for service', service.itemId);
            }
          },
          error: (err) => {
            console.error('Error retrieving user:', err);
            this.alertService.error('Unable to retrieve user information.');
            resolve('');
          }
        });
      }, this.DEBOUNCE_MS);
    });
  }

  async generateICSInternal(input): Promise<string> {
    const now = Date.now();
    if (this.lastIcsRequest &&
      (now - this.lastIcsRequest) < this.GUIDANCE_COOLDOWN_MS) {
      console.log(`Guidance generation throttled for ICS. Please wait.`);
      this.alertService.error('Please wait a moment before generating another guidance.');
      return '';
    }

    if (this.guidanceDebounceTimeout) {
      clearTimeout(this.guidanceDebounceTimeout);
    }

    return new Promise((resolve) => {
      this.guidanceDebounceTimeout = setTimeout(() => {
        var allProps = [
          'operatingSystem',
          'database',
          'fileStorage',
          'containerScanning',
          'architecture',
          'devLanguage',
          'configurationManagement',
          'accessManagement',
          'keyManagement',
          'firewall',
          'codeRepository',
          'immutability',
          'monitoring',
          'codeScanning',
          'applicationScanning',
          'desktopSecurity',
          'userAuth',
          'loginSecurity',
        ]
        this.userService.getCurrent().subscribe({
          next: async (user: any) => {

            const prompt = `Hey ChatGPT, Please provide an implementation control statement along with Key Implementation Components and assessment evidence to help me prepare for an assessment of the ${this.originalProjectControlItem.controlItem.complianceAreaName} ${this.originalProjectControlItem.controlItem.complianceAreaControlId} control if we are using ${allProps.map(p => `- ${p.replace(/([A-Z])/g, ' $1')} is ${input[p + 'Value']} at ${input[p + 'Status']}\r\n`).join(' and ')} to address it.`;
          console.log(prompt);
            if (!this.icsLoadingMessage) {
              this.icsLoadingMessage = true;
              this.cdr.detectChanges();

              let rawOutput = '';
              let errorMessage = '';
              let outputSet = false;

              try {

                const activeProvider = user.llmProviders?.find((p: any) => p.isActive);
                if (!activeProvider || !activeProvider.encryptedApiKey) {
                  this.alertService.error('No active LLM provider found. Please fill in this information under LLM Blockchain in Account Profile.');
                  throw new Error('No active LLM provider/api key found.');
                }
                const api_key = EncryptHelper.decrypt(activeProvider.encryptedApiKey);
                const providerName = activeProvider.provider?.toLowerCase() || '';
                let [provider, ...rest] = providerName.toLowerCase().split('-');
                let model = rest.join("-");

                const data = await this.callProvider(provider, providerName, model, api_key, prompt);
                rawOutput = JSON.stringify(data);

                if (data?.choices?.[0]?.message?.content) {
                  const content = data.choices[0].message.content.trim();
                  this.icsOutput = content.replace(/\n/g, '<br>');
                  outputSet = true;
                  this.lastIcsRequest = Date.now();
                  resolve(this.icsOutput);
                } else {
                  errorMessage = 'No valid content returned from LLM.';
                  throw new Error(errorMessage);
                }
              } catch (e: any) {
                errorMessage = e?.message || 'Unknown error';
                console.error('Error generating guidance:', errorMessage, 'Raw output:', rawOutput);

                setTimeout(() => {
                  this.icsOutput =
                    `Failed to generate guidance.<br><br><b>Raw LLM output:</b><br><pre>${rawOutput || '[none]'}</pre>`;
                  this.alertService.error(`Error generating guidance: ${errorMessage}<br><pre>${rawOutput || '[none]'}</pre>`);
                  this.icsLoadingMessage = false;
                  this.cdr.detectChanges();
                  resolve(this.icsOutput);
                }, 3000);
              } finally {
                if (outputSet) {
                  this.icsLoadingMessage = false;
                  this.cdr.detectChanges();
                }
              }
            } else {
              console.log('ICS generation already in progress');
            }
          },
          error: (err) => {
            console.error('Error retrieving user:', err);
            this.alertService.error('Unable to retrieve user information.');
            resolve('');
          }
        });
      }, this.DEBOUNCE_MS);
    });
  }

  generateICS() {
    const itProfile = this.clientProfile[0] || {};
    this.icsLoadingMessage = false;
    const input = {
      operatingSystemStatus: this.iscComponentStatuses[itProfile.operatingSystemStatus],
      databaseStatus: this.iscComponentStatuses[itProfile.databaseStatus],
      fileStorageStatus: this.iscComponentStatuses[itProfile.fileStorageStatus],
      containerScanningStatus: this.iscComponentStatuses[itProfile.containerScanningStatus],
      architectureStatus: this.iscComponentStatuses[itProfile.architectureStatus],
      devLanguageStatus: this.iscComponentStatuses[itProfile.devLanguageStatus],
      configurationManagementStatus: this.iscComponentStatuses[itProfile.configurationManagementStatus],
      accessManagementStatus: this.iscComponentStatuses[itProfile.accessManagementStatus],
      keyManagementStatus: this.iscComponentStatuses[itProfile.keyManagementStatus],
      firewallStatus: this.iscComponentStatuses[itProfile.firewallStatus],
      codeRepositoryStatus: this.iscComponentStatuses[itProfile.codeRepositoryStatus],
      immutabilityStatus: this.iscComponentStatuses[itProfile.immutabilityStatus],
      monitoringStatus: this.iscComponentStatuses[itProfile.monitoringStatus],
      codeScanningStatus: this.iscComponentStatuses[itProfile.codeScanningStatus],
      applicationScanningStatus: this.iscComponentStatuses[itProfile.applicationScanningStatus],
      desktopSecurityStatus: this.iscComponentStatuses[itProfile.desktopSecurityStatus],
      userAuthStatus: this.iscComponentStatuses[itProfile.userAuthStatus],
      loginSecurityStatus: this.iscComponentStatuses[itProfile.loginSecurityStatus],
      operatingSystemValue: itProfile.operatingSystemValue,
      databaseValue: itProfile.databaseValue,
      fileStorageValue: itProfile.fileStorageValue,
      containerScanningValue: itProfile.containerScanningValue,
      architectureValue: itProfile.architectureValue,
      devLanguageValue: itProfile.devLanguageValue,
      configurationManagementValue: itProfile.configurationManagementValue,
      accessManagementValue: itProfile.accessManagementValue,
      keyManagementValue: itProfile.keyManagementValue,
      firewallValue: itProfile.firewallValue,
      codeRepositoryValue: itProfile.codeRepositoryValue,
      immutabilityValue: itProfile.immutabilityValue,
      monitoringValue: itProfile.monitoringValue,
      codeScanningValue: itProfile.codeScanningValue,
      applicationScanningValue: itProfile.applicationScanningValue,
      desktopSecurityValue: itProfile.desktopSecurityValue,
      userAuthValue: itProfile.userAuthValue,
      loginSecurityValue: itProfile.loginSecurityValue,
    };

    const confirmDialogRef = this.dialog.open(GuidanceDialogComponent, {
      width: '600px',
      data: {
        confirmation: true,
        input
      }
    });

    confirmDialogRef.afterClosed().subscribe(action => {
      if (action === 'confirm') {
        if (!this.icsLoadingMessage) {
          this.alertService.loading.next(true);
          this.alertService.info("Hang on... mixing your Elixir can sometimes take 3 to 5 minutes.");
          this.generateICSInternal(input).then(result => {
            this.loading = false;
            this.icsLoadingMessage = false;
            if (result) {
              const dialogRef = this.dialog.open(GuidanceDialogComponent, {
                width: '80%',
                data: { guidance: result }
              });
              dialogRef.afterClosed().subscribe(action => {
                if (action === 'save') {
                  this.originalProjectControlItem.implementationControlStatementId = null;
                  this.originalProjectControlItem.solutionDescription = result;
                  this.updateScore();
                  this.cdr.detectChanges();
                }
              });

            }
          }).catch(err => {
            this.alertService.error('ICS Generation Error: ' + err);
          }).finally(() => {
            this.alertService.loading.next(false);
          });
        }
      } else {
        this.loading = false;
        this.alertService.loading.next(false);
        console.log('ICS generation cancelled by user');
      }
    });
  }

  async callProvider(provider, providerName, model, api_key, prompt){
    console.log('Making API request for guidance generation with prompt:', prompt);
    console.log("Provider and Model: ", provider, model);
    let response;
    const TEMPERATURE = 1;
    switch (provider) {
      case 'openai':
        response = await fetch("https://api.openai.com/v1/chat/completions", {
          method: "POST",
          headers: {
            "Authorization": `Bearer ${api_key}`,
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            model: model || "gpt-5",
            temperature: TEMPERATURE,
            messages: [{ role: "user", content: prompt }]
          })
        });
        break;

      case 'anthropic':
        response = await fetch("https://api.anthropic.com/v1/messages", {
          method: "POST",
          headers: {
            "x-api-key": api_key,
            "Content-Type": "application/json",
            "anthropic-version": "2023-06-01"
          },
          body: JSON.stringify({
            model: model || "claude-3-opus-20240229",
            temperature: TEMPERATURE,
            messages: [{ role: "user", content: prompt }],
            max_tokens: 1024
          })
        });
        break;

      case 'google':
        response = await fetch(`https://generativelanguage.googleapis.com/v1beta/models/${model || "gemini-pro"}:generateContent?key=${api_key}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            contents: [{ parts: [{ text: prompt }] }]
          })
        });
        break;

      case 'meta':
      case 'llama':
      case 'mistral':
      case 'groq':
        response = await fetch("https://api.groq.com/openai/v1/chat/completions", {
          method: "POST",
          headers: {
            "Authorization": `Bearer ${api_key}`,
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            model: model || "llama-3.1-8b-instant",
            temperature: TEMPERATURE,
            messages: [{ role: "user", content: prompt }]
          })
        });
        break;

      case 'cohere':
        response = await fetch("https://api.cohere.ai/v1/chat", {
          method: "POST",
          headers: {
            "Authorization": `Bearer ${api_key}`,
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            model: model || "command-r-plus",
            message: prompt,
            temperature: TEMPERATURE
          })
        });
        break;

      case 'perplexity':
        response = await fetch("https://api.perplexity.ai/chat/completions", {
          method: "POST",
          headers: {
            "Authorization": `Bearer ${api_key}`,
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            model: model || "mistral-7b-instruct",
            messages: [{ role: "user", content: prompt }]
          })
        });
        break;

      default:
        throw new Error(`Unsupported provider: ${providerName}`);
    }

    if (!response.ok) {
      const error = await response.text();
      throw new Error(`Error ${response.status}: ${error}`);
    }

    return await response.json();
  }

  generateGuidanceForService(service: any) {
    const profile = this.clientProfile[0] || {};
    this.guidanceLoadingMessage = true;
    const input = {
      vendor: service.vendor || 'N/A',
      topic: service.securityTopic || 'N/A',
      solutionName: service.name || 'N/A',
      requirement: this.originalProjectControlItem?.controlItem?.name || 'N/A',
      deploymentType: profile.deploymentType || 'N/A',
      primaryOS: profile.primaryOS || 'N/A',
      idMgmtProduct: profile.identityManagement || 'N/A',
      primaryFirewallProd: profile.firewallProduct || 'N/A',
      primaryConfigMgmtProduct: profile.configManagementProduct || 'N/A',
      primaryDevLang: profile.devLanguage || 'N/A',
      securityToolsDeployed: profile.securityTools || 'N/A',
      otherKeyTech: profile.otherTech1 || 'N/A'
    };

    const confirmDialogRef = this.dialog.open(GuidanceDialogComponent, {
      width: '600px',
      data: {
        confirmation: true,
        input
      }
    });

    confirmDialogRef.afterClosed().subscribe(action => {
      if (action === 'confirm') {
        if (!this.guidanceLoading[service.itemId]) {
          this.alertService.loading.next(true);
          this.alertService.info("Hang on... mixing your Elixir can sometimes take 3 to 5 minutes.");
          this.guidanceOutputs[service.itemId] = 'Loading...';
          this.generateGuidance(service).then(result => {
            this.loading = false;
            this.guidanceLoadingMessage = false;
            if (result) {
              const dialogRef = this.dialog.open(GuidanceDialogComponent, {
                width: '80%',
                data: { guidance: result }
              });
              dialogRef.afterClosed().subscribe(action => {
                if (action === 'save') {
                  const existingItem = this.originalProjectControlItem.workstreamItems?.find(item =>
                    item.controlItems?.some(ci => ci.controlItemId === this.originalProjectControlItem.controlItemId)
                  );

                  if (existingItem) {
                    existingItem.elixir = result;
                    this.workstreamService.saveWorkstreamItem(existingItem).subscribe({
                      next: () => {
                        this.alertService.success('Guidance saved to workstream!');
                        this.cdr.detectChanges();
                      },
                      error: (err) => {
                        this.alertService.error('Failed to save guidance: ' + err.message);
                      }
                    });
                  } else {
                    const selectedVendor = input.vendor;
                    const selectedServiceName = input.solutionName;
                    const sharedResponsibility = this.originalProjectControlItem.sharedResponsibilities?.find(
                      sr => sr.service.parent === selectedVendor && sr.service.name === selectedServiceName
                    );
                    if (sharedResponsibility?.service) {
                      sharedResponsibility.service.elixir = result;
                      sharedResponsibility.elixir = result;
                      //console.log('Updated shared responsibility with elixir:', sharedResponsibility);
                      const dictionaryItem = this.services.find(
                        d => d.itemId === sharedResponsibility.dictionaryItemId
                      );
                      if (dictionaryItem) {
                        dictionaryItem.elixir = result;
                        //console.log('Updated dictionary item with elixir:', dictionaryItem);
                        this.dictionaryService.save({ ...dictionaryItem })
                      } else {
                        console.log(this.services);
                      }
                      this.sharedResponsibilityForm.setValue({
                        responsibility: sharedResponsibility.responsibility,
                        vendorId: sharedResponsibility.service.parentId,
                        serviceId: sharedResponsibility.dictionaryItemId,
                        securityTopic: sharedResponsibility.service.securityTopic,
                        contacts: sharedResponsibility.contacts,
                        elixir: result
                      });

                      this.onSave();
                    } else {
                      console.warn('Could not find matching shared responsibility using vendor and name match');
                    }
                  }
                }
              });

            }
          }).catch(err => {
            this.alertService.error('Guidance Generation Error: ' + err);
          }).finally(() => {
            this.alertService.loading.next(false);
          });
        }
      } else {
        this.loading = false;
        this.alertService.loading.next(false);
        console.log('Guidance generation cancelled by user');
      }
    });
  }


  isFuture(item: any): boolean {
    const due = this.extractDueDate(item);
    if (!due) return false;

    const d = new Date(due);
    if (isNaN(d.getTime())) return false;

    const today = new Date();
    d.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    return d.getTime() > today.getTime();
  }

  private extractDueDate(item: any): Date | string | number | null {
    if (!item) return null;
    if (item instanceof Date) return item;
    if (typeof item === 'string' || typeof item === 'number') return item;
    if (typeof item === 'object' && 'dueDate' in item) return (item as any).dueDate ?? null;
    return null;
  }

  forceLocalToUtc(dateString: string): Date {
    const local = new Date(dateString);
    return new Date(Date.UTC(
      local.getFullYear(),
      local.getMonth(),
      local.getDate(),
      local.getHours(),
      local.getMinutes(),
      local.getSeconds()
    ));
  }


  onCustomDateChanged(date: Date) {
    if (!date) return;
    const picked = moment(date).startOf('day');

    const existing = this.originalProjectControlItem.completionPeriods
      .find(cp => moment(cp.dueDate).isSame(picked, 'day'));

    if (existing) {
      this.selectedCompletionPeriod = existing;
      this.completionPeriodChange(existing);
      return;
    }

    const newPeriod = {
      dueDate: DatesHelper.formatDate(picked.toDate()),
      completionPeriodId: 0,
      projectControlItemId: this.originalProjectControlItem.projectControlItemId,
      note: null,
      completedInRizkly: null,
      temporary: false,
      isCompleted: false,
      actualDate: null
    };

    this.originalProjectControlItem.completionPeriods.push(newPeriod);

    this.originalProjectControlItem.completionPeriods.sort((a, b) =>
      moment(a.dueDate).valueOf() - moment(b.dueDate).valueOf()
    );

    this.selectedCompletionPeriod = newPeriod;
    this.completionPeriodChange(newPeriod);
  }

  onFrequencyChange(value){
    if (value === 0){
      this.selectedCompletionPeriod = null;
    }
  }

  selectFindingsNotes(index, field, form) {
    const confirmDialogRef = this.dialog.open(SelectDictionaryItemComponent, {
      width: '90%',
      data: {
        dictionary: 'FindingsNotes'
      }
    });

    confirmDialogRef.afterClosed().subscribe(action => {
      if (action) {
        if (index >= 0) {
          this.originalProjectControlItem.findingsNotesList[index] = action.details;
        }
        else if (form) {
          form.controls[field].setValue(action.details);
        } else {
            this.originalProjectControlItem[field] = action.details;
        }
        this.cdr.detectChanges();
      }
    });
  }

  format(operator, path, expected, found) {
    switch (operator) {
      case 'Equals':
        return `${path} not equal to ${found}`;
      case 'NotEquals':
        return `${path} equals to ${found}`;
      case 'Contains':
        return `${path} does not contain ${expected}`;
      case 'NotContains':
        return `${path} contains ${expected}`;
      case 'Greater':
        return `${path} is not greater than ${found}`;
      case 'Less':
        return `${path} is not less than ${found}`;
    }
    return '';
  }

  selectRecommendations(index) {
    const confirmDialogRef = this.dialog.open(SelectDictionaryItemComponent, {
      width: '90%',
      data: {
        dictionary: 'Recommendations'
      }
    });

    confirmDialogRef.afterClosed().subscribe(action => {
      if (action) {
        this.originalProjectControlItem.recommendationsList[index] = action.details;
        this.cdr.detectChanges();
      }
    });
  }

  isViewable(item) {
    return !!this.supportedViewExtensions.find(e => (item.name || '').indexOf('.' + e) > 0);
  }

  viewEvidence(item) {
    const confirmDialogRef = this.dialog.open(ViewFileComponent, {
      width: '90%',
      data: {
        url: this.config.api + '/api/attachments/file?path='+ 'Projects/' +
          this.project.name +
          (this.userMap[this.originalProjectControlItem.assignedClientId]
            .role == Role.Vendor
            ? '/Vendors/' +
            encodeURIComponent(
              this.userMap[
                this.originalProjectControlItem.assignedClientId
                ].emailAddress.replace('@', '_')
            )
            : '') +
          '/Evidence/' +
          this.originalProjectControlItem.shortFolderName +
          '&token=' + LoginHelper.getFileToken() +
          '&name='+ encodeURIComponent(item.name)
      }
    });
  }

  onCompletionStatusChanged(value) {
    if (value) {
      this.selectedCompletionPeriod.actualDate = moment(this.selectedCompletionPeriod.dueDate).add(12, 'hour').toDate();
      this.selectedCompletionPeriod.completedInRizkly = moment().toDate();
    }
    else{
      this.selectedCompletionPeriod.actualDate = null;
      this.selectedCompletionPeriod.completedInRizkly = null;
    }
  }

  updateScore(){
    if (this.settings) {
      this.originalProjectControlItem.dynamicScore =
        (this.originalProjectControlItem.solutionDescription || this.originalProjectControlItem.solutionDescription2 || this.originalProjectControlItem.solutionDescription3 ? this.settings.implementationStatusScore : 0) +
        (this.originalProjectControlItem.evidences.length ? this.settings.evidenceScore : 0) +
        (this.originalProjectControlItem.policies.length ? this.settings.policyScore : 0) +
        (this.originalProjectControlItem.actionPlans.find(a => a.status !== 'Resolved') ? 0 : this.settings.poamScore);
    }
  }

  refreshCriteria(){
    this.criteriaItemsMet = this.criteriaItems.filter(i => i.userValue * 1 > 0).length;
    this.criteriaSum = this.criteriaItems.map(i => i.userValue * 1).reduce((a, s) => a + s, 0);
    this.criteriaTotalSum = this.criteriaItems.map(i => i.value * 1).reduce((a, s) => a + s, 0);
  }
}
